export const lv = {
    addDatabase: {
        addDatabase: "Pievienot datu bÄzi",
        addFromFile: "Pievienot no datu bÄzes",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "All packages",
        onePackage: "One package",
        priceType: "Cenas tips",
        setPriceVatVisibility: "Set VAT visibility",
        setVisibilityAndOrder: "IestatÄ«t redzamÄ«bu un kÄrtÄ«bu",
        withAndWithoutVat: "Abi, gan ar, gan bez PVN",
        withVat: "Tikai ar PVN",
        withoutVat: "Tikai bez PVN"
    },
    barvis: {
        base: "BÄze",
        bigCanSize: "Lielais iepakojums",
        coating: "PÄrklÄjums",
        identifier: "Identifikators",
        laboratory: "Laboratorija",
        orderOverview: "PasÅ«tÄ«juma pÄrskats",
        rank: "PopularitÄte",
        smallCanSize: "Mazais iepakojums"
    },
    basicSetup: {
        alreadyLoggedIn: "JÅ«s jau esat pierakstÄ«jies kÄ %{login}",
        askSupplier: "JautÄjiet savam piegÄdÄtÄjam pieÅ¡Ä·irt jums papildus licences",
        asterisk: "Lauki apzÄ«mÄti ar zvaigznÄ«ti jÄaizpilda obligÄti",
        identificationKeys: "Identification keys",
        importCustomData: "Ja ir iespÄjams, importÄjiet savus datus no iepriekÅ¡ÄjÄs tonÄÅ¡anas progammas",
        learnIdentification: "Uzziniet par identifikÄcijas atslÄgÄm no sava programmu piegÄdÄtÄja",
        login: "SekojoÅ¡iem iestatÄ«Å¡anas soÄ¼iem nepiecieÅ¡amas administratora tiesÄ«bas",
        noDatabase: "Nav pievienota datubÄze, nepiecieÅ¡ama vismaz viena",
        offlineLicensing: "Offline licensing",
        productSelection: "Product selection",
        registrationForm: "Registration form",
        seeQuestionMark: "Uzpiediet uz jautÄjuma zÄ«mÄ«tÄm, lai uzzinÄtu vairÄk par iestatÄ«jumiem",
        selectDefaultPrinter: "IzvÄlieties noklusÄto printeri un veiciet tÄ papildu konfigurÄciju",
        selectDefaultTemplate:
            "IzvÄlieties gatavÄs sagataves no esoÅ¡ajÄm, izveidojiet jaunu sagatavi vai ielÄdÄjiet citas",
        selectDispenser: "IzvÄlieties maÅ¡Ä«nas tipu, ko lietojat",
        selectLanguage: "IzvÄlieties valodu",
        selectProducts: "IzvÄlieties vienu no produktiem, ko vÄlaties aktivÄt",
        selectSpectroType: "IzvÄlieties spektrometra tipu, ko lietojat",
        setAdditionalPrinterOptions: "Iestatiet papildus printera iestatÄ«jumus",
        setAutomaticUpdates: "Iestatiet automÄtiskÄs atjaunoÅ¡anas iestatÄ«jumus",
        setCustomItems:
            "Iestatiet individuÄlos parametrus un datu redzamÄ«bu. RullÄjiet uz leju, lai redzÄtu vairÄk izvÄles",
        setEnvironment: "Iestatiet vispÄrÄjo programmatÅ«ras vidi. RullÄjiet uz leju, lai redzÄtu vairÄk izvÄles",
        setFormulaRepresentation: "Iestatiet receptes parÄdÄ«Å¡anos. RullÄjiet uz leju, lai redzÄtu vairÄk izvÄles",
        summary: "JÅ«s varat izmainÄ«t Å¡os iestatÄ«jumus jebkurÄ laikÄ un atrast vÄl vairÄk iespÄju. Baudiet %{name}!",
        summarySuccess: "JÅ«s esat visu paveicis!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "LÄ«menis kolbÄ",
        criticalLevelCanister: "Kritiskais lÄ«menis kolbÄ",
        fillToMax: "UzpildÄ«t lÄ«dz pilnam",
        maxDispenseLevel: "MaksimÄlais dozÄÅ¡anas lÄ«menis",
        otherCanisters: "Citas kolbas",
        warningLevelCanister: "BrÄ«dinÄjuma lÄ«menis kolbÄ"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "IespÄjamÄs servisa darbÄ«bas",
        canisterInformation: "Kolbu informÄcija",
        canisterPreview: "Kolbu priekÅ¡skatÄ«jums",
        currentLevel: "AktuÄlais lÄ«menis",
        errors: "KÄ¼Å«das",
        fillState: "UzpildÄ«Å¡anas minimÄlais lÄ«menis",
        fillToMax: "UzpildÄ«t lÄ«dz pilnam",
        fillingAmount: "Filling amount",
        finalLevel: "Final level",
        minimumAmount: "MinimÄlais daudzums",
        minimumLevel: "MinimÄlais lÄ«menis",
        moveTableToRefill: "Pagriezt kolbu uzpildÄ«Å¡anai",
        refillNoAmount: "NeievadÄ«t nekÄdu daudzumu",
        refillOverLimit: "IevadÄ«tais daudzums pÄrsniedz maksimÄlo kolbas ietilpÄ«bu",
        refillSummary: "%{amount} %{unit} of the colorant %{colorant} will be added to the canister %{canisterId}.",
        systemWarningAmount: "SistÄmas brÄ«dinÄjuma lÄ«menis",
        warningAmount: "Rezerves brÄ«dinÄjuma lÄ«menis"
    },
    changeDatabase: {
        changeDatabase: "IzmainÄ«t datu bÄzi",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "TÄ«rÄ«t visas sprauslas",
        cleanChannels: "TÄ«rÄ«t sprauslas",
        cleaningTime: "TÄ«rÄ«Å¡anas laiks",
        selectChannels: "IzvÄlÄties sprauslu",
        startCleaning: "SÄkt tÄ«rÄ«Å¡anu"
    },
    clientServerSettings: {
        activeServer: "AktÄ«vais serveris",
        addNewServer: "Pievienot jaunu serveri",
        availableServers: "Pieejamie serveri",
        clientIdentifier: "Klienta identifikators",
        clientServerSettings: "Klienta/servera iestatÄ«jumi",
        disabledStatus: "DeaktivÄts",
        editServer: "IzmainÄ«t serverÄ«",
        fillRequiredFields: "AizpildÄ«t pieprasÄ«tos laukus",
        noOtherServers: "Nav citu pieejamu serveru",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "PieslÄgums",
        serverName: "Servername",
        serverNameMissing: "IerakstÄ«t servera nosaukumu",
        stabileConnection: "Lai nodroÅ¡inÄtu stabilu savienojumu, lietojiet statisku IP adresi",
        wrongFormatIp: "Nepareizs IP adreses formÄts"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "KrÄsas tonis",
        fandeckPosition: "Paletes pozÄ«cija",
        moreInfoIcons: "More info icons",
        notExistingFormula: "NeeksistÄjoÅ¡a receptÅ«ra",
        orderBy: "SakÄrtot pÄc",
        selectYourGrid: "IzvÄlÄties lÄ«niju",
        showInPanel: "ParÄdÄ«t panelÄ«",
        warningIcon: "BrÄ«dinÄjuma ikona"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Pigmentu skaits",
        preview: "Kolbas",
        prices: "Cena par litru"
    },
    currencySettings: {
        addNewCurrency: "Pievienot jaunu valÅ«tu",
        codePlaceholder: "Kods",
        currencySettings: "ValÅ«tas iestatÄ«jumi",
        namePlaceholder: "Nosaukums",
        ratePlaceholder: "VÄrtÄjums",
        setDecimalPlaces: "IestatÄ«t decimÄldaÄ¼skaitÄ¼us",
        setMainCurrency: "Pamata valÅ«ta",
        setRounding: "NoapaÄ¼ot",
        symbolPlaceholder: "Simbols"
    },
    customFandecks: {
        customFandecks: "IndividuÄlÄs paletes",
        deleteButtonWarning: "All formulas in fandeck will be removed too.",
        deleteCustomFandeck:
            "Do you really want to delete this custom fandeck? All formulas in this fandeck will be deleted too.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Paletes nosaukums"
    },
    customRedlike: {
        addColorantFromBrand: "Add colorant from %{brandName} brand",
        addNewCustomer: "Pievienot jaunu klientu",
        addNewNote: "Pievienot jaunu piezÄ«mi",
        addedDate: "Datums pievienots",
        addedQuantity: "Daudzums pievienots",
        availableMachine: "PieejamÄ maÅ¡Ä«na",
        brand: "Marka",
        brandPlease: "IzvÄlÄties marku",
        cancelCustomer: "Atcelt klientu",
        colorPlease: "LÅ«dzu izvÄlÄties toni",
        confirmCustomerData: "Apstipriniet klienta datus",
        confirmNoteData: "Apstipriniet piezÄ«mi",
        confirmSelectedUser: "ApstiprinÄt izvÄlÄto lietotÄju %{customerName}",
        confirmed: "ApstiprinÄts",
        controlData: "GalÄ«gÄ datu pÄrbaude",
        customerCellNumber: "Klienta mob. telefona numurs",
        customerFilter: "Klientu filtrs",
        customerName: "Klienta vÄrds",
        customerPhone: "Klienta telefona numurs",
        customerPlease: "IzvÄlÄties klientu",
        dateFilter: "Datumu filtrs",
        enterPin: "IevadÄ«t PIN kodu",
        enterTheNumberOfPackages: "IevadÄ«t iepakojumu daudzumu",
        existingCustomer: "TÄds klients jau eksistÄ!",
        fandeckPlease: "IzvÄlÄties paleti",
        fillCanisterHistory: "AizpildÄ«t kolbu piepildÄ«Å¡anas vÄsturi",
        findCustomer:
            "Lai aizpildÄ«tu Å¡Ä« pasÅ«tÄ«juma klienta karti, lÅ«dzam noskanÄt svÄ«trukodu vai meklÄt pÄc e-mail adreses",
        findCustomerByEmail: "Atrast klientu pÄc e-maila",
        finishPreviousStep: "Pabeidziet iepriekÅ¡Äjo darbÄ«bu!",
        formulaUnit: "RezeptÅ«ras vienÄ«ba",
        getBackToList: "AtpakaÄ¼ uz klientu sarakstu",
        historyOfOrders: "PasÅ«tÄ«jumu vÄsture",
        insertNote: "Pievienot piezÄ«mi",
        loadHistoryOrder: "Vai vÄlaties ielÄdÄt izvÄlÄto pasÅ«tÄ«jumu?",
        loyaltyCards: "Klientu kartes",
        machineIsAvailable: "MaÅ¡Ä«na ir pieejama",
        machineIsUnavailable: "MaÅ¡Ä«na nav pieejama",
        newLoyaltyCard: "Jauna klieta karte",
        noAvailableMachine: "Nav pieejamu maÅ¡Ä«nu",
        noCustomerSelected: "Nav izvÄlÄts klients",
        notePlease: "LÅ«dzu pievienot piezÄ«mi",
        openHistory: "AtvÄrt vÄsturi",
        orAdd: "Vai pievienot klientu",
        orSelect: "Vai izvÄlÄties klientu",
        orderModification: "The original order will be modified. Do you want to continue?",
        orderOverview: "PasÅ«tÄ«jumu pÄrskats",
        orderToMachine: "PasÅ«tÄ«jumu nosÅ«tÄ«t uz maÅ¡Ä«nu",
        ordersHistory: "PasÅ«tÄ«jumu vÄsture",
        packagePlease: "IzvÄlÄties iepakojumu",
        pleaseSelectBrand: "IzvÄlÄties marku",
        previewImage: "PriekÅ¡skatÄ«t attÄlu",
        previewPackage: "PriekÅ¡skatÄ«t iepakojumu",
        productPlease: "IzvÄlÄties produktu",
        resetFilters: "AtiestatÄ«t visus filtrus",
        searchForHistoricalOrders: "MeklÄt pasÅ«tÄ«jumu vÄsturÄ",
        selectBrand: "IzvÄlÄties marku",
        selectColor: "IzvÄlÄties toni",
        selectCustomer: "IzvÄlÄties klientu",
        selectExistingCustomer: "IzvÄlÄties esoÅ¡o klientu",
        selectFandeck: "IzvÄlÄties paleti",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "IzvÄlÄties iepakojumu",
        selectProduct: "IzvÄlÄties produktu",
        shotsCoefficient: "DozÄÅ¡anas koeficients",
        showDetail: "ParÄdÄ«t detaÄ¼as",
        showHideEshopName: "Show/Hide the eshop name of the color in a separate column",
        showKeyboard: "ParÄdÄ«t tastatÅ«ru",
        skipCustomerButton: "Izlaist klientu izvÄli ",
        skipCustomerText: "Izlaist, ja nevÄlaties ievadÄ«t klientu",
        skipNote: "Izlaist piezÄ«mes",
        spectroBrand: "Searching in brand %{brandName}",
        statusAccepted: "AkceptÄts",
        statusCanceled: "NoraidÄ«ts",
        statusCreated: "Izveidots",
        statusDone: "Gatavs",
        statusPartlyDone: "DaÄ¼Äji gatavs",
        statusPreparing: "SagatavoÅ¡anÄ",
        summaryChosenBase: "BÄze",
        summaryChosenBrand: "Marka",
        summaryChosenCanSize: "Iepakojums",
        summaryChosenColor: "Tonis",
        summaryChosenColorCard: "Palete",
        summaryChosenProduct: "Produkts",
        summaryChosenQuantity: "Daudzums",
        summaryColorPreview: "ToÅa priekÅ¡skatÄ«jums",
        summaryCustomNote: "PiezÄ«me",
        summaryCustomerNumber: "Klienta numurs",
        summaryFormula: "ReceptÅ«ra",
        summaryFormulaNote: "ReceptÅ«ras piezÄ«me",
        summaryNote: "PiezÄ«me",
        sureAboutSend: "TieÅ¡Äm nosÅ«tÄ«t pasÅ«tÄ«jumu?",
        useCustomerInOrder: "VÄlaties ierakstÄ«t klientu %{customerName} pasÅ«tÄ«jumÄ?",
        uuid: "UUID",
        viewSummary: "SkatÄ«t kopsavilkumu",
        volume: "Apjomi"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "PIN apstiprinÄÅ¡ana",
        pinScreenSaverConfirmation: "PIN ekrÄna saudzÄtÄja apstiprinÄÅ¡ana",
        pinSettingsConfirmation: "PIN iestatÄ«jumu apstiprinÄÅ¡ana",
        printAuto: "AutomÄtiska printÄÅ¡ana",
        printerSettings: "Printera iestatÄ«jumi",
        selectColorWithFandeck: "IzvÄlÄties krÄsu pÄc paletes",
        setKeyboard: "TastatÅ«ra",
        setKioskMode: "Kioska formÄts",
        setLanguage: "Valoda",
        setModule: "Modulis",
        setQuickSelect: "ÄtrÄ izvÄlne",
        setScreensaverTimeout: "EkrÄna saudzÄtÄja sagaidÄ«Å¡anas laiks",
        setUnit: "VienÄ«ba"
    },
    customRedlikeMachine: {
        action: "DarbÄ«ba",
        additionalPrint: "DrukÄt papildus etiÄ·eti",
        brand: "Marka",
        brandAccess: "LietotÄjam '%{userName} nav pieejas '%{brandName}",
        can: "Kolba pozÄ«cijÄ",
        canistersLevel: "Kolbu lÄ«menis",
        closeDetailInformation: "AizvÄrt detalizÄciju",
        colorantsAmount: "Pigmenta daudzums",
        confirmRefill: "AptiprinÄt pigmeta uzpildi",
        deleteOrder: "DzÄst pasÅ«tÄ«jumu",
        dialogNoMachine: "Nav savienojuma",
        dialogNoRcc: "Nav savienojuma ar RCC",
        dispense: "DozÄt",
        dispenserInErrorState: "KÄ¼Å«da maÅ¡Ä«nÄ!",
        dispensingIsOk: "MaÅ¡Ä«na kÄrtÄ«bÄ!",
        emergencyButtonPressed: "Nospiests avÄrijas slÄdzis!",
        errorCode: "KÄ¼Å«das kods",
        errorEvents: "MaÅ¡Ä«nas kÄ¼Å«da ",
        errorReset: "AtiestatÄ«t maÅ¡Ä«nas kÄ¼Å«du",
        explanation: "Paskaidrojums",
        imageNotAvailable: "AttÄls nav pieejams",
        incorrectCanister: "NoskanÄta nepareiza kolba!",
        incorrectColorant: "KÄ»ÅªDA: Nepareizais pigments! LÅ«dzu izvÄlÄties pareizo pigmentu!",
        lastEvents: "PÄdÄjie notikumi",
        machineActions: "MaÅ¡Ä«nas darbÄ«bas",
        machineConfiguration: "MaÅ¡Ä«nas konfigurÄcija",
        machineError: "MaÅ¡Ä«nas kÄ¼Å«da",
        machineIsBusy: "MaÅ¡Ä«na aizÅemta!",
        machineNotAvailable: "MaÅ¡Ä«na nav pieejama",
        machineTinting: "LÅ«dzam uzgaidÄ«t, notiek dozÄÅ¡ana",
        manualScan: "ManuÄlÄ skanÄÅ¡ana",
        notEnoughSpace: "KÄ¼Å«da: Å¡im pigmentu daudzumam nepietiek vietas!",
        numberOfCanistersUnderCriticalLevel: "Kolbu skaits zem kritiskÄ uzpildes lÄ«meÅa ir %{0}",
        numberOfCanistersUnderWarningLevel: "Kolbu skaits zem brÄ«dinÄjuma lÄ«meÅa ir %{0}",
        offlinePressed: "Nospiests offline taustiÅÅ¡",
        orderSettings: "PasÅ«tÄ«juma iestatÄ«jumi",
        otherOrderInformation: "PasÅ«tÄ«juma detaÄ¼as",
        packageCount: "Iepakojumu skaits",
        packageWithSeparator: "Iepakojumi",
        received: "SaÅemts",
        receivedOrders: "SaÅemts pasÅ«tÄ«jums",
        receivedTime: "SaÅemÅ¡anas laiks",
        recirculation: "RecirkulÄcija",
        refillInformation: "Pigments: %{0}, LÄ«menis: %{1}, Kolba: %{2}",
        resetErrors: "AtiestatÄ«t maÅ¡Ä«nas kÄ¼Å«das",
        scanCanister: "NoskanÄjiet kolbu",
        scanColorantPackage: "NoskanÄjiet pigmenta iepakojumu",
        selectedOrder: "IzvÄlÄtais pasÅ«tÄ«jums",
        shelfMovingDown: "Plaukts tiek nolaists",
        shelfMovingUp: "Plaukts tiek pacelts",
        solution: "Å Ä·Ä«dums",
        startDispensing: "SÄkt dozÄÅ¡anu",
        stirring: "MaisÄ«Å¡ana",
        touchToStartFilling: "Nospiest lai sÄktu uzpildi",
        unknownBrand: "NepazÄ«stama marka"
    },
    customRedlikeSettings: {
        addPos: "POS informÄcija",
        addServer: "Pievienot Serveri",
        adminOperations: "Admin operations",
        adminSettings: "Administratora iestatÄ«jumi",
        another: "Cits",
        aslOrService: "ASL vai serviss",
        availableMachines: "PieejamÄs maÅ¡Ä«nas",
        barcode: "SvÄ«trukods",
        basicOperations: "PamatoperÄcijas",
        canisterBarcodes: "Kolbu svÄ«trukodi",
        canisterLevels: "Kolbu uzpildes lÄ«meÅi",
        closeConnection: "Close connection",
        closeRedlike: "AizvÄrt %{name}",
        databaseList: "Datu bÄzu saraksts",
        disabledStatus: "â NeaktÄ«vs",
        dispenseLogicType: "DozÄÅ¡anas loÄ£iskais tips",
        dropServers: "AktualizÄt pieejamos serverus",
        editServer: "MainÄ«t serverÄ«",
        lastEvent: "PÄdÄjais notikums",
        logOut: "Iziet",
        machineConfiguration: "KonfigurÄcija",
        maxDispenseAmount: "MaksimÄlais dozÄÅ¡anas daudzums",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        openFrondesk: "AtvÄrt priekÅ¡Äjo paneli",
        print: "Drukas iestatÄ«jumi",
        rebootPC: "PÄrstartÄt datoru",
        restartRedlike: "PÄrstartÄt %{name}",
        restoreConnection: "Atjaunot savienojumu",
        scanCanisterBarcode: "NoskanÄjiet kolbas svÄ«trukodu",
        scanOrDeleteCanisterBarcode: "SkanÄjiet vai noraidiet svÄ«trukodu",
        setCanisterBarcode: "IestatÄ«t kolbas svÄ«trukodu",
        swVersion: "Programmas versija",
        systemFunctions: "SistÄmas funkcijas",
        userSettings: "LietotÄja iestatÄ«jumi"
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "MainÄ«t krÄsu",
        editColorant: "MainÄ«t pigmentu",
        emptyColorant: "Pigments daudzums nav definÄts",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formula for master product",
        formulaForMasterProductWithParam: "Formula for master product %{productName}",
        isNotAvailable: "Nav pieejams",
        noBaseSelected: "Nav izvÄlÄta bÄze",
        noColorantsSelected: "Nav izvÄlÄti pigmenti",
        noFandeckSelected: "Nav izvÄlÄta palete",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Nav izvÄlÄts produkts",
        productPreview: "Produkta priekÅ¡skatÄ«jums",
        saveCustomRecipe: "SaglabÄjiet individuÄlo recepti",
        saveIsNotAvailable: "Nav iespÄjams saglabÄt",
        showSiblingProducts: "Show sibling products",
        siblingProducts: "Sibling products by master product"
    },
    customersTab: {
        addCustomer: "Pievienot klientu",
        additionalSettings: "Additional Settings",
        adress: "Adrese",
        createAndSelect: "Izveidot un izvÄlÄties",
        createNewCustomer: "Izveidot jaunu klienta profilu",
        editCustomer: "Labot klienta profilu",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Identification number",
        information: "KontaktinformÄcija",
        listOfCustomers: "Klientu saraksts",
        rabat: "Atlaide",
        selectCustomer: "IzvÄlÄties klientu",
        spentLastMonth: "PatÄriÅÅ¡ pÄdÄjÄ mÄneÅ¡a laikÄ",
        spentMoney: "Izmaksas",
        typeOfMargin: "Uzcenojuma veids",
        zipCode: "Pasta indekss"
    },
    dialog: {
        cheaperColorSearch: "Cheaper color search is in progress",
        competitiveColorSearch: "Notiek salÄ«dzinoÅ¡Ä krÄsu meklÄÅ¡ana",
        reallyChangeModule: "Vai tieÅ¡Äm vÄlaties mainÄ«t moduli?",
        reallyCloseRedlike:
            "Vai tieÅ¡Ä vÄlaties aizvÄrt %{name}? Visi %{name} paneÄ¼i tiks aizvÄrti, nesaglabÄtÄs izmaiÅas tiks zaudÄtas",
        reallyDeleteOrder:
            "Vai tieÅ¡Äm vÄlaties aizvÄrt Å¡o pasÅ«tÄ«jumu? Visi dati, kas saistÄ«ti ar Å¡o pasÅ«tÄ«jumu tiks zaudÄti",
        reallyRebootPC:
            "Vai tieÅ¡Äm vÄlaties restartÄt Å¡o datoru? Visi paneÄ¼i tiks aizvÄrti, nesaglabÄtÄs izmaiÅas tiks  zaudÄtas",
        reallyRestartRedlike:
            "Vai tieÅ¡Äm vÄlaties restartÄt %{name}? Visi paneÄ¼i tiks aizvÄrti, nesaglabÄtÄs izmaiÅas tiks  zaudÄtas",
        reallyShutdownPc:
            "Vai tieÅ¡Äm vÄlaties izslÄgt Å¡o datoru? Visi %{name} paneÄ¼i tiks aizvÄrti, nesaglabÄtÄs izmaiÅas tiks  zaudÄtas",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "DozÄt tikai maksimÄli tonÄjamo daudzumu ",
        2: "ManuÄlo dozÄÅ¡anu veikt  ar maksimÄlo dozÄÅ¡anas daudzumu skalas palÄ«dzÄ«bu",
        3: "UzpildÄ«t tonÄÅ¡anas laikÄ (daudzumus sadalÄ«t mazÄkÄs daÄ¼Äs)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "PaleÅ¡u nosaukumi"
    },
    editFormulaRgbModal: {
        apply: "Pielietot",
        blue: "Zils",
        green: "ZaÄ¼Å¡",
        modalLabel: "ModelÄt krÄsu",
        red: "Sarkans",
        tryGenerateRgb: "Try to generate RGB by colorant amounts"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Close formula tab automatically",
        allowBarcodes: "AtÄ¼aut svÄ«trukodus",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "AtÄ¼aut rÄdÄ«t klientus",
        allowDeleteConfirmation: "AtÄ¼aut dzÄÅ¡anas apstiprinÄjumu",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "AtÄ¼aut dozÄt",
        allowFileTransfer: "Allow automatic file transfer",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Allow formula status panel",
        allowInternalNotes: "Allow internal notes",
        allowLight: "AtÄ¼aut %{name}",
        allowOrderNotificationModal: "ParÄdÄ«t jauna pasÅ«tÄ«juma ziÅojumu",
        allowOrdering: "AtÄ¼aut pasÅ«tÄ«jumus",
        allowPricing: "AtÄ¼aut cenas",
        allowPrint: "Allow print",
        allowProductPreviewImage: "AtÄ¼aut produkta attÄla priekÅ¡skatÄ«jumu dozÄÅ¡anas laikÄ",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Allow searching for cheaper colors",
        allowSound: "AtÄ¼aut skaÅas signÄlus",
        allowSpectro: "AtÄ¼aut spektrometru",
        allowTabs: "Allow tabs",
        applyZoom: "Pielietot palielinÄjumu",
        automaticLogout: "Automatic logout",
        barcodeScan: "Barcode Scan",
        canisterBarcode: "Kolbu svÄ«trukodi",
        canisterLevel: "Kolbu lÄ«menis",
        changelog: "IzmaiÅu log",
        closeTab: "AizvÄrt karti",
        colorDifference: "Color difference",
        colorPanelNavItem: "KrÄsu panelis",
        competitiveColorSearch: "SalÄ«dzinoÅ¡Ä krÄsu meklÄÅ¡ana",
        customBanner: "IndividuÄls baneris",
        customCurrencyFormat: "Currency format",
        customDateFormat: "Date format",
        customNumberFormat: "Number format",
        customTimeFormat: "Time format",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Show discount",
        dispensingHistory: "DozÄÅ¡anas vÄture",
        dispensingNotes: "DozÄÅ¡anas piezÄ«mes",
        enableCustomers: "AtÄ¼aut klientus",
        enableDeleteConfirmation: "DzÄÅ¡anas apstiprinÄjums",
        enableDispensing: "AtÄ¼aut dozÄÅ¡anu",
        enableLight: "AtÄ¼aut %{name}",
        enableMarginMarkup: "AtÄ¼aut iestatÄ«t uzcenojumu",
        enableNotes: "AtÄ¼aut piezÄ«mes",
        enableOrdering: "AtÄ¼aut pasÅ«tÄ«jumus",
        enableProductPreviewImage: "AtÄ¼aut produkta attÄla priekÅ¡skatÄ«jumu",
        enableSpectro: "AtÄ¼aut spektrometru",
        enableVirtualKeyboard: "AtÄ¼aut virtuÄlo tastatÅ«ru",
        environmentsSettings: "SistÄmas iestatÄ«jumi",
        exportTranslationKeys: "EksportÄt tulkoÅ¡anas kodus",
        formulaNotes: "AtÄ¼aut piezÄ«mes receptÅ«rÄ",
        hintTooltips: "ParÄdÄ«t ieteikumus",
        image: "AttÄls",
        keyboardShortcuts: "TastatÅ«ras Ä«sceÄ¼i",
        languageBased: "Language based",
        lockYourComputer: "AizslÄgt datoru",
        machineReset: "PÄrstartÄt maÅ¡Ä«nu",
        manageTranslations: "PÄrvaldÄ«t tulkojumus",
        margin: "MarÅ¾a tikai ",
        markup: "Uzcenojums",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "MaksimÄlais tabulu daudzums",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "KrÄsa + attÄls + vairÄk info",
        navigationItems: "NavigÄcijas elementi",
        newTab: "Jauna tabula",
        numberOfPriceGroups: "Number of price groups",
        order: "PasÅ«tÄ«jums",
        orderId: "PasÅ«tÄ«juma ID",
        ordersHistory: "PasÅ«tÄ«jumu vÄsture",
        overwriteLastTab: "Overwrite last formula tab",
        priceCalculation: "Price calculation",
        priceDefBothPurchasePrimary: "Both, purchase primary",
        priceDefBothSellPrimary: "Both, sell primary",
        priceDefPurchaseOnly: "Purchase price only",
        priceDefSellOnly: "Sell price only",
        priceDefinition: "Price definition",
        priceGroupsEnabled: "Enable price groups",
        runLightAtStartUp: "AtvÄrt %{light} startÄjot datoru",
        screenSaverTimeout: "Screensaver timeout",
        selectedSpectro: "Selected %{spectro} spectro.",
        selectedSpectroNone: "No spectro selected.",
        setAutomaticClientStart: "IestatÄ«t automÄtisku %{name} atvÄrÅ¡anu startÄjot",
        setCustomHomeButton: "IestatÄ«t mÄjas pogu",
        setDecimalPlaces: "IestatÄ«t decimÄldaÄ¼skaitÄ¼us",
        setFormulaPreview: "IestatÄ«t receptÅ«ras priekÅ¡skatÄ«jumu",
        setFormulaUnit: "IestatÄ«t receptÅ«ras mÄrvienÄ«bas",
        setFts: "IestatÄ«t teksta meklÄÅ¡anu",
        setInfoItemInRgb: "IestatÄ«t informÄciju krÄsu priekÅ¡skatÄ«jumam",
        setKeyboardShortcuts: "IestatÄ«t tastatÅ«ras Ä«sceÄ¼us",
        setKioskMode: "IestatÄ«t kioska veidÄ",
        setKioskModeOff: "IestatÄ«t kioska veida izslÄgÅ¡anu",
        setKioskModeOn: "IestatÄ«t kioska veida ieslÄgÅ¡anu",
        setNavigationItems: "IestatÄ«t navigÄcijas rÄ«kus",
        setNavigationItemsList: "IestatÄ«t navigÄcijas rÄ«ku sarakstu",
        setOrderSearchItems: "IestatÄ«t pasÅ«tÄ«juma meklÄÅ¡anas rÄ«kus",
        setRounding: "IestatÄ«t noapaÄ¼oÅ¡anu",
        setSearchParameters: "IestatÄ«t meklÄÅ¡anas parametrus",
        setTabLimit: "IestatÄ«t tabulu ierobeÅ¾ojumus",
        setYourLanguage: "IestatÄ«t valodu",
        setZoom: "IestatÄ«t palielinÄjumu",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Izlaist kolbu novietoÅ¡anas dialoga atÄ¼auÅ¡anu, jo tas jau ir slÄgts maÅ¡Ä«nas iestatÄ«jumos",
        sortItems: "Å Ä·irot navigÄcijas elementus",
        startDispensing: "SÄkt dozÄÅ¡anu",
        stir: "MaisÄ«Å¡ana"
    },
    error: {
        errorDetail: "KÄ¼Å«das detaÄ¼as",
        errorOccurred:
            "ParÄdÄ«jusies negaidÄ«ta kÄ¼Å«da, griezties pie atbalsta personÄla %{0}. SazinÄsimies ar jums pÄc iespÄjas ÄtrÄk",
        hideDetail: "SlÄpt detaÄ¼u"
    },
    favoritesTab: {
        addFolder: "Pievienot mapi",
        closeTabToLoadFormula:
            "Lai atvÄrtu jaunu tabulu, lÅ«dzam slÄgt kÄdu no senÄkÄm tabulÄm. Jums ir atvÄrts maksimÄli pieÄ¼aujamais tabulu skaits",
        deleteFolder: "DzÄst mapi",
        editFolder: "KoriÄ£Ät mapi",
        favoriteFormulas: "IecienÄ«tÄkÄs receptÅ«ras",
        formulaNotes: "ReceptÅ«ras piezÄ«mes",
        message: {
            formulasFromFolder: "Receptes no tabulas",
            moveAllFormulas: "PÄrcelt visas receptÅ«ras no Å¡Ä«s mapes uz pÄrdÄvÄto mapi",
            removeAllFormulas: "IzdzÄst visas receptes no Å¡Ä«s mapes",
            wantToDeleteFolder: "Vai tieÅ¡Äm vÄlaties dzÄst Å¡o mapi?"
        },
        newFolder: "Jauna mape",
        packages: "Iepakojumi",
        pricePerPackage: "Iepakojuma cena",
        regularPrice: "RegulÄrÄ cena",
        removeFromFavorites: "NoÅemt no favorÄ«tiem",
        specialPriceOff: "SpeciÄlÄ cena %{number}%",
        specialPriceVIP: "SpeciÄlÄ cena VIP"
    },
    fileTransfer: {
        afterImport: "After import",
        alreadyExists: "Task for given type and format already exists",
        customFormulaSimple: "Custom formula simple",
        direction: "Direction",
        exportTask: "File export task",
        fileTransferNotification: "File transfer notification",
        flashMessage: "Flash message",
        importTask: "File import task",
        noInformation: "No information",
        protocol: {
            folder: "Folder",
            ftp: "FTP protocol",
            ftps: "FTPS protocol",
            redlikeStorage: "%{softwareName} FTP storage protocol",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protocol checking files in defined local folder.",
            ftp: "Protocol checking files in remote FTP folder using standard FTP connection.",
            ftps: "Protocol checking files in remote FTPS (FTP-SSL / FTP Secure) server using standard FTP connection.",
            redlikeStorage: "Protocol checking files in %{softwareName} storage."
        },
        remoteFolder: "Remote folder",
        startType: "Start type",
        statusbar: "Statusbar information",
        testConnection: "Test connection",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Consumption type",
        filter: "Filtrs",
        from: "No",
        to: "LÄ«dz"
    },
    findText: {
        findTextTitle: "Find text",
        removeMarks: "Remove marks",
        search: "Search word"
    },
    flashMessage: {
        VMNotAllowed: "VirtuÄlÄ maÅ¡Ä«na nav atÄ¼auta",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Database autologin failed.",
        autotaskDuplicateName: "Datu krÄtuves kÄ¼Å«da: %{0} elements ar %{1} %{2} jau eksistÄ, lÅ«dzam lietot citu %{3}",
        barcodeIsUsed: "The barcode is already used.",
        barcodeNotFound: "SvÄ«trukods nav atrasts",
        bugReportSent: "Atskaite par kÄ¼Å«du nosÅ«tÄ«ta",
        cannoctConnectToServer: "Nevar savienoties ar serveri",
        cannotWriteLicense: "Nevar rakstÄ«t licenci",
        clientConnectionRejected: "Savienojums noraidÄ«ts",
        clientNotLoggedIn: "Nav pierakstÄ«jies",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty:
            "No competitive colors could be found. Change searching parameters or select a different color.",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Dators atiestatÄ«ts",
        connectionFailed: "Connection test failed: %{0}",
        connectionSuccess: "Connection test was successful",
        corruptedLicenseFile: "BojÄts licences fails",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Klients nav atrasts",
        dataNotAvailable: "Nevar savienoties ar datu krÄtuvi",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "PÄdÄjÄs servera darbÄ«bas laikÄ radÄs negaidÄ«ta kÄ¼Å«da",
        deleteAll: "DzÄst visu",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin: "Varat deaktivÄt ziemas savienojumu, izvÄloties no drop-down saraksta kartes labajÄ pusÄ",
        duplicateBarcode: "Duplicate barcode already exists.",
        duplicateName: "VÄrda dublikÄts",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licence ir beigusies",
        exportSuccess: "Dati veiksmÄ«gi eksportÄti",
        fandeckExist: "Å Äds krÄsu paletes nosaukums jau eksistÄ",
        featureNotAutorized: "NeautorizÄta funkcija",
        fileExportComplete: "Datu eksports pabeigts",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "File not provided or is empty.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Could not process data in file, file is not valid.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Could not detect version of file.",
        filetransferNoData: "No database connection, check settings",
        formulaDataUnavailable: "Receptes dati nav pieejami",
        helperDefaultMessage: "PÄdÄjÄs Helper-Server darbÄ«bas rezultÄtÄ ir radusies negaidÄ«ta kÄ¼Å«da",
        helperServerError: "Helper-Server kÄ¼Å«da",
        importAborted: "Datu imports tika pÄrtraukts",
        importSuccess: "Dati veiksmÄ«gi importÄti",
        incompatibleBaseCan: "BÄzes iepakojums nav savietojams ar izvÄlÄtÄ produkta bÄzi un iepakojumu",
        incorrectPassword: "VecÄ parole nav derÄ«ga. LÅ«dzam ievadÄ«t pareizo paroli",
        invalidCurrency: "ValÅ«tas kods nav derÄ«gs. Eiro ir iestatÄ«ts kÄ standarta valÅ«ta",
        invalidDatabaseName: "Datu bÄzes nosaukums nav derÄ«gs",
        invalidEmail: "E-mail adrese nav derÄ«ga",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "NederÄ«ga kompÄnijas lietotÄja parole",
        invalidLicenseFile: "NederÄ«gi licences dati",
        invalidLicenseIdentificationKeys: "Licences identifikÄcijas atslÄga nav derÄ«ga",
        invalidLicenseKey: "Licence nav derÄ«ga",
        invalidLicenseProduct: "Produkts nav licencÄts",
        invalidRccResponse: "ApstrÄdÄjot pÄdÄjo RCC atbildi radusies negaidÄ«ta kÄ¼Å«da",
        invalidServerResponse: "ApstrÄdÄjot pÄdÄjo atbildi no servera radusies negaidÄ«ta kÄ¼Å«da",
        invalidUrl: "URL nav derÄ«gs",
        itemNotFound: "Artikuls nav atrasts",
        keyboardShortcutUsedInModal:
            "Å Ä« taustiÅu kombinÄcija nav pieÄ¼aujama modÄlajÄ logÄ. LÅ«dzam vispirms slÄgt modÄlo logu",
        keyboardShortcutValidation: "JÅ«s nevarat pielietot to paÅ¡u taustiÅu kombinÄciju divÄm daÅ¾ÄdÄm komandÄm ",
        licenseHasBeenRevoked:
            "JÅ«su licence ir beigusies. Lai to atjaunotu, lÅ«dzam kontaktÄties ar programmatÅ«ras piegÄdÄtÄju",
        licenseProlongationNeeded:
            "NepiecieÅ¡ams licences pagarinÄjums (pievienot datoru internetam, lai iegÅ«tu jaunu licenci)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "SÄkotnÄji licencÄts uz cita datora",
        logFileArchiveDownloadComplete: "PierakstÄ«Å¡anÄs log arhÄ«vs veiksmÄ«gi ielÄdÄts",
        loginError: "Pierakstoties radusies negaidÄ«ta kÄ¼Å«da",
        logoutError: "Izrakstoties radusies negaidÄ«ta kÄ¼Å«da",
        machineIsConnecting: "MaÅ¡Ä«na savienojas, lÅ«dzu uzgaidiet",
        machineIsNotConnected: "MaÅ¡Ä«na nav savienojusies ar RCC, lÅ«dzu pÄrbaudÄ«t RCC konfigurÄciju",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "MaksimÄlais atvÄrto tabulu skaits, lÅ«dzam kÄdu aizvÄrt",
        noTemplate: "Nav iespÄjams izprintÄt jo nav pieejami Å¡abloni",
        openNewTab: "Please open a new formula tab to load formula using barcode",
        orderAlreadyAcquired: "PasÅ«tÄ«jums jau ir iesniegts, lÅ«dzam vispirms apstiprinÄt",
        orderCreated: "PasÅ«tÄ«jums tikai veiksmÄ«gi nosÅ«tÄ«ts",
        passwordIsNotUnique: "Jaunajai parolei jÄbÅ«t atÅ¡Ä·irÄ«gai no iepriekÅ¡ÄjÄs",
        printCannotBeCarriedOut: "Nav iespÄjams izprintÄt, nav pareizi definÄts printeris",
        problemWithFileExport: "Notikusi kÄ¼Å«da saglabÄjot uz diska",
        productFileWarning: "Product file is only available online.",
        productNotLicensed: "Produkts nav licencÄts",
        rccDefaultMessage: "PÄdÄjai RCC darbÄ«bai radusies negaidÄ«ta kÄ¼Å«da",
        rccError: "RCC kÄ¼Å«da",
        rccNeedRestart: "LÅ«dzam pÄrstartÄt RCC",
        restoredSettings: "Settings have been restored.",
        revokedLicense: "Licence tika pÄrtraukta",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Recepte tika veiksmÄ«gi saglabÄta vÄturÄ",
        savedLogArchive: "PierakstÄ«Å¡anÄs log arhÄ«vs veiksmÄ«gi saglabÄts",
        scanning: "Scanning in progress",
        serverError: "Servera kÄ¼Å«da",
        setClientIdentifier: "IestatÄ«t klienta identifikÄciju",
        showLess: "ParÄdÄ«t mazÄk",
        showMore: "ParÄdÄ«t vairÄk",
        spectroIsDisconnecting: "Spektrometrs atvienojas, lÅ«dzam uzgaidÄ«t",
        spectroIsNotConnected: "Spektrometrs paÅ¡laik nav pievienots, lÅ«dzu pÄrbaudÄ«t RCC konfigurÄciju",
        spectroIsNotSelected: "Spektrometrs paÅ¡laik nav izvÄlÄts, lÅ«dzu pÄrbaudÄ«t RCC konfigurÄciju",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "NezinÄma kÄ¼Å«da: %{0}",
        userAlreadyLoggedIn: "JÅ«s esat pierakstÄ«jies",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Nevar savienoties ar Web-api serveri",
        webApiInternalError: "Web-api servera iekÅ¡ÄjÄ kÄ¼Å«da",
        webApiInvalidUser: "Web-api servera nederÄ«gs lietotÄjs",
        webApiNoLicenseAvailable: "Web-api serverim nav licences",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Nepareizs %{0} ievades formÄts ",
        wrongRccVersion: "LÅ«dzu pÄrbaudiet jÅ«su RCC versiju. IespÄjama savietojamÄ«ba tikai ar RCC %{0} versiju"
    },
    footer: {
        aboutApplication: "About application",
        activeUser: "Active user",
        logOut: "IzrakstÄ«ties",
        machineErrors: "MaÅ¡Ä«nas kÄ¼Å«das"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "All units available in the database",
        allowCustomFormulas: "AtÄ¼aut individuÄlas receptÅ«ras",
        allowCustomPackageSize: "AtÄ¼aut manuÄlu iepakojuma izvÄli",
        allowFormulaAutomaticNaming: "AtÄ¼aut automÄtisku nosaukumu pieÅ¡Ä·irÅ¡anu",
        automaticNaming: "AutomÄtiska nosaukumu pieÅ¡Ä·irÅ¡ana",
        basePanelSize: "Set size of base panel",
        bippPanelSize: "Set size of base in product package panel",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "KrÄsu panelis",
        colorPreviewAsImage: "Color preview as image",
        colorPreviewResizable: "Resizable color preview",
        competitiveColorSearch: "SalÄ«dzinoÅ¡Ä krÄsu meklÄÅ¡ana",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "IndividuÄlas receptÅ«ras",
        customPackageSettingsUnitGrav: "Custom package settings gravimetric unit",
        customPackageSettingsUnitVol: "Custom package settings volumetric unit",
        customPackageSize: "ManuÄli mainÄms iepakojums",
        customUnits: "Choose custom units",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "IzmainÄ«t pigmentus",
        editColorantsAllowed: "AtÄ¼aut izmainÄ«t pigmentus",
        fandeckPanelSize: "Set size of fandeck panel",
        favoriteFormulas: "FavorÄ«ti",
        formulaColorPreview: "ReceptÅ«ras toÅa priekÅ¡skatÄ«jums",
        formulaDataSettings: "ReceptÅ«ras datu iestatÄ«jumi",
        formulaPanel: "ReceptÅ«ru panelis",
        formulaPanelSize: "Set size of color panel",
        formulaSettings: "ReceptÅ«ru iestatÄ«jumi",
        generateColorPreview: "Generate color preview",
        gravimetricOnly: "Gravimetric units only",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Use only image from local database",
        imagesOnline: "Primarily, try to open online image, if it fails, open local image",
        infoPanelResizable: "Resizable more info panel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Unit depends on the selected product",
        productFilesDialog: "Show dialog to open local file or online file",
        productFilesLocal: "Use only product files from local database",
        productFilesOnline: "Primarily, try to open online product file, if it fails, open local file",
        productPanelSize: "Set size of product panel",
        searchPanelQuickSelect: "Quick select",
        setAdditionalFormulaPanel: "Izveidot papildus receptÅ«ru paneli",
        setCompetitiveColorSearch: "Enable competitive color search",
        setInitialFormulaPanel: "Izveidot sÄkotnÄjo receptÅ«ru paneli",
        setMaxToleranceForCompetitiveColors: "IestatÄ«t maksimÄlo toleranci salÄ«dzinoÅ¡ajai krÄsu meklÄÅ¡anai",
        setNumberOfCompetitiveColors: "IestatÄ«t salÄ«dzinoÅ¡o krÄsu skaitu",
        setSearchPanel: "IestatÄ«t meklÄÅ¡anas paneli",
        setVisibilityAndOrder: "IestatÄ«t redzamÄ«bu un kÄrtÄ«bu",
        setVisibleUnit: "IestatÄ«t redzamÄs vienÄ«bas",
        showColorPreview: "ParÄdÄ«t toÅa priekÅ¡skatÄ«jumu",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Colorant panel sorting",
        useBase: "Use selection item for base",
        useBaseInProductPackage: "Use selection item for base in product package",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Use selection item for product",
        useProductCode: "Use product code",
        useProductGroups: "Use product groups",
        volumetricOnly: "Volumetric units only"
    },
    general: {
        accepted: "Accepted",
        active: "PÄdÄjÄ aktivitÄte",
        actual: "AktuÄli",
        actualLevel: "AktuÄlais uzpildes lÄ«menis",
        add: "Pievienot",
        addColorant: "Pievienot pigmentu",
        addColorantForPackage: "Add colorant for package",
        addFile: "Add file",
        all: "Viskas",
        amount: "Daudzums",
        applyNow: "Apply now",
        attachments: "Attachments",
        automaticCorrection: "Automatic correction",
        automatically: "Automatically",
        available: "Available",
        back: "AtpakaÄ¼",
        base: "BÄze ",
        baseInProductPackage: "BÄze produktam un iepakojumam",
        batchNumber: "Batch number",
        bottom: "ApakÅ¡a",
        buildingSite: "Building site",
        calculate: "Calculate",
        can: "Iepakojums",
        canSize: "Iepakojuma lielums",
        cancel: "Atcelt",
        canister: "Canister",
        canisterId: "Kolbas-ID",
        canisterIndex: "Canister Index",
        canisters: "Kolbas",
        cap: "VÄks",
        capacity: "IetilpÄ«ba",
        channels: "Kolba",
        choose: "IzvÄlÄties",
        city: "PilsÄta",
        clean: "NotÄ«rÄ«t",
        clear: "TÄ«rÄ«t",
        client: "Klients",
        close: "AizvÄrt",
        closeAll: "Close all",
        collapseAll: "Collapse all",
        color: "KrÄsa",
        colorCode: "KrÄsu kods",
        colorFile: "Colorfile",
        colorName: "KrÄsas nosaukums",
        colorPreview: "KrÄsas priekÅ¡skatÄ«jums",
        colorant: "Pigments",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Pigmenta iepakojums",
        colorants: "Pigmenti",
        colors: "Colors",
        company: "UzÅÄmums",
        competitiveColor: "Competitive color",
        confirm: "ApstiprinÄt",
        confirmDeletion: "ApstiprinÄt pilnÄ«gu dzÄÅ¡anu?",
        confirmHelpSettings: "Vai tieÅ¡Äm atstÄt tukÅ¡us laukus?",
        connect: "Savienot",
        continue: "TurpinÄt",
        correction: "Correction",
        country: "Country",
        created: "Izveidots",
        creationDateOf: "Creation date of",
        criticalLevel: "Kritiskais lÄ«menis",
        currency: "Currency",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "IndividuÄlÄs receptÅ«ras",
        customData: "Custom data",
        customFandeck: "IndividuÄla palete",
        customFormula: "Custom formula",
        customPackage: "ManuÄlÄ ievade",
        customPackageSettings: "Custom package settings",
        customer: "Klients",
        customerVersion: "Klientu versija",
        customers: "Klienti",
        database: "Datu krÄtuve",
        date: "Datums",
        default: "Default",
        delete: "DzÄst",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Apraksts",
        disconnect: "Atvienot",
        discount: "Discount",
        discover: "AtklÄt",
        dispense: "Spalvinimas",
        dispensing: "DozÄt",
        doNotShowAgain: "Do not show this message again.",
        downloadingFile: "LejuplÄdÄt datus",
        edit: "Labot",
        email: "Email",
        enabled: "AktivizÄt",
        error: "KÄ¼Å«da",
        expandAll: "Expand all",
        exportData: "Export data",
        exportPdf: "Export PDF",
        fan: "Palete",
        fandeck: "Kolekcija",
        fandeckCode: "Fandeck code",
        fandeckName: "Paletes nosaukums",
        fandecks: "Fandecks",
        favorite: "FavorÄ«ts",
        fileTransfer: "File transfer",
        filling: "UzpildÄ«Å¡ana",
        fillingDate: "Filling date",
        find: "Atrast",
        finish: "Finish",
        finishedCorrection: "Finished correction",
        formula: "ReceptÅ«ra",
        formulas: "Formulas",
        frontdesk: "Frontdesk",
        getQrCode: "SaÅemt QR kodu",
        gravimetric: "Gravimetric",
        historical: "Historical",
        history: "VÄsture",
        hours: "Hou.",
        id: "ID",
        images: "Images",
        in: "In",
        index: "Indekss",
        insertBarcode: "IevadÄ«t svÄ«rtukodu",
        install: "InstalÄt",
        installed: "InstalÄts",
        instructions: "Instructions",
        internalNote: "Internal note",
        interval: "Interval",
        ip: "IP adrese",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "Limit",
        load: "Load",
        loadFormula: "IelÄdÄt toni",
        localVersion: "VietÄjÄ versija",
        machine: "MaÅ¡Ä«na",
        manualCorrection: "Manual correction",
        manually: "Manually",
        margin: "MarÅ¾a",
        markup: "Uzcenojums",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "MaksimÄlais uzpildes lÄ«menis",
        maxValue: "Max value",
        maximum: "Maksimums",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minimums",
        minutes: "Min.",
        missingItem: "Pazudis elements",
        missingRequiredItems: "AizpildÄ«t visus pieprasÄ«tos (atzÄ«mÄtos ar zvaigznÄ«ti) laukus",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "VairÄk",
        moreInfo: "VairÄk informÄcijas",
        moveDown: "Nolaist uz leju",
        moveUp: "Pacelt uz augÅ¡u",
        myOrders: "Mani pasÅ«tÄ«jumi",
        name: "VÄrds",
        nameTitle: "Pavadinimas",
        new: "Jauns",
        next: "NÄkoÅ¡ais",
        no: "NÄ",
        noColorantsAvailable: "Nav pieejami pigmenti",
        noFormulas: "VÄl nav receptÅ«ras",
        noPricesAvailable: "Cenas nav pieejamas",
        nominalAmount: "NominÄlais apjoms",
        notAvailable: "Nav pieejams",
        note: "PiezÄ«me",
        numberOfCanisters: "Kolbu skaits",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "UzlÄ«mju skaits",
        numberOfPackages: "Iepakojumu skaits",
        off: "IzslÄgts",
        ok: "OK",
        on: "IeslÄgts",
        onFocus: "On focus",
        open: "AtvÄrt  ",
        operator: "Operator",
        options: "IespÄjas",
        order: "Order",
        other: "Cits",
        otherError: "Cita kÄ¼Å«da",
        out: "Out",
        overwrite: "Overwrite",
        package: "Iepakojums",
        packagePreview: "Iepakojuma priekÅ¡skatÄ«jums",
        partialUpdates: "Partial updates",
        phone: "Telefons",
        pleaseWait: "Please wait",
        previous: "Previous",
        price: "Cena",
        priceGroup: "Price group",
        print: "DrukÄt",
        printTask: "Print task",
        processingStep: "Processing %{step}",
        product: "Produkts",
        productCode: "Product code",
        productName: "Product name",
        products: "Produkti",
        pump1: "Pompa 1",
        pump2: "Pompa 2",
        purchasePrice: "Purchase price",
        purge: "IzpÅ«st sprauslas",
        qualityControl: "Quality control",
        quantity: "Daudzums",
        quantityQty: "QTY",
        quickTint: "ManuÄlÄ dozÄÅ¡ana",
        rccIsNotAvailable: "RCC nav pieejams",
        rccIsNotConnected: "RCC nav savienots",
        rccNotLicensed: "RCC nav licencÄts",
        reconnect: "Savienot no jauna",
        refill: "UzpildÄ«t  ",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "Atjaunot  ",
        restart: "PÄrstartÄt",
        restore: "Restore",
        retint: "Retint",
        revision: "PÄrbaude",
        safetySheet: "Safety sheet",
        save: "SaglabÄt",
        saveAs: "SaglabÄt kÄ ",
        saveToDispensingHistory: "SaglabÄt tonÄÅ¡anas vÄsturÄ",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sec.",
        select: "Select",
        selectAll: "IzvÄlÄties visu",
        selectChannels: "IzvÄlÄties kolbas",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "Sell price",
        settings: "IestatÄ«jumi",
        shelf: "Plaukts",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Size",
        skip: "Izlaist  ",
        smartPurge: "Smart purge",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometrs",
        standardFormula: "Standard formula",
        status: "Statuss",
        street: "Iela",
        sum: "Sum",
        summary: "Kopsavilkums",
        sync: "SinhronizÄt",
        technicalSheet: "Technical sheet",
        templates: "Sagataves",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Uz dozÄÅ¡anas pasÅ«tÄ«jumiem",
        top: "AugÅ¡a",
        total: "KopÄ",
        totalAmount: "Total amount",
        totalBaseAmount: "Total base amount",
        totalColorantAmount: "Total colorants amount",
        type: "Type",
        ufiCode: "UFI code",
        ufiThreshold: "UFI threshold",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Unit",
        units: "VienÄ«bas",
        unknown: "Unknown",
        update: "AktualizÄcija",
        updated: "AktualizÄts",
        user: "LietotÄjs",
        value: "Value",
        vat: "PVN",
        verified: "Verified",
        version: "Versija",
        versionId: "Versijas ID",
        versionStructure: "Versijas struktÅ«ra",
        volumetric: "Volumetric",
        warning: "BrÄ«dinÄjums",
        warningLevel: "BrÄ«dinÄjuma lÄ«menis",
        withoutName: "(without name)",
        workingProperly: "Working properly",
        yes: "JÄ",
        zoom: "Zoom"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the brush container automatically at the defined time. The dispenser operator needs to remove, clean, and then return the brush container manually.",
            capMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the cap automatically at the defined time. The dispenser operator needs to clean the autocap manually after it opens.",
            cleanAll:
                "Set this autotask to have the dispenser perform the action for cleaning all channels automatically at the defined time.",
            cleanChannels:
                "Set this autotask to have the dispenser perform the action for cleaning specific channels automatically at the defined time.",
            computerReboot: "Set this autotask to have the computer rebooted automatically at the define time.",
            computerShutdown: "Set this autotask to have the computer turned off automatically at the define time.",
            dispenserCleaning:
                "Set this autotask to have %{name} request the action for cleaning the dispenser automatically at the defined time. The dispenser operator needs to clean the machine with a cloth manually.",
            humidifierWaterLevelMaintenance:
                "Set this autotask to have %{name} request the action for refilling the humidifier automatically at the defined time. The dispenser operator needs to check and refill the water in the humidifier manually.",
            purgeAll:
                "Set this autotask to have the dispenser perform the action for purging all channels automatically at the defined time.",
            purgeChannels:
                "Set this autotask to have the dispenser perform the action for purging specific channels automatically at the defined time.",
            recirculateAll:
                "Set this autotask to have the dispenser perform the action for recirculating all channels automatically at the defined time.",
            recirculateChannels:
                "Set this autotask to have the dispenser perform the action for recirculating specific channels automatically at the defined time.",
            refillAll:
                "Set this autotask to have %{name} request the action for refilling all channels automatically at the defined time. The dispenser operator needs to refill colorants into all canisters manually.",
            refillCanisters:
                "Set this autotask to have %{name} request the action for refilling specific channels automatically at the defined time. The dispenser operator needs to manually refill colorants into canisters which do not meet the refill criterion.",
            smartPurgeAll:
                "Set this autotask to have the dispenser perform the action for smart purging all channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            smartPurgeChannels:
                "Set this autotask to have the dispenser perform the action for smart purging specific channels automatically at the defined time. Purge will be carried out unless the Smart purge rules are met.",
            stirAll:
                "Set this autotask to have the dispenser perform request the action for stirring all channels automatically at the defined time.",
            stirCanisters:
                "Set this autotask to have the dispenser perform request the action for stirring specific channels automatically at the defined time.",
            switchPlateMaintenance:
                "Set this autotask to have %{name} request the action for cleaning the switch plate automatically at the defined time. The dispenser operator needs to remove, clean, and then return the switch plate manually."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Allows to add a new server manually if it could not be detected via the Discover function.",
            clientIdentifier:
                "The setting enables to identify this client if there are more clients connected to one server.",
            disconnect:
                "Information about the currently used server. The disconnect button allows to leave this server and switch to another one if available.",
            discover: "Discovers whether there are any other servers available in the network.",
            dropServers: "Deletes all previously detected servers from the list.",
            dropServersNotAvailable: "No server available",
            edit: "Allows to manually edit an already found server.",
            editDisabled: "No server selected."
        },
        continue: "Do you really want to continue?",
        driverSettings: {
            alfaRestApi: {
                host: "Ierakstiet datorÄ servera nosaukumu vai IP adresi",
                machineType: "DerÄ«gs visÄm Alfa maÅ¡Ä«nÄm. Gan Windows, gan Linux"
            },
            corobDsProxy: {
                machineType:
                    "DerÄ«gs paaudzei Slave (D200, D600..), 4G (First One) un 5G (EvoFlx). JÄbÅ«t instalÄtam DspProxy. Tikai Windows"
            },
            corobEvoDriver: {
                machineType: "DerÄ«gs paaudzei 5G (EvoFlx). EVOservsam jÄbÅ«t instalÄtam. Gan Windows, gan Linux"
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "IzvÄlieties dozatora konfigurÄcijas failu. NoklusÄjuma iestatÄ«jumi",
                hldRootDir: "IzvÄlieties galveno HLD folderi. NoklusÄjuma iestatÄ«jumi.",
                machineType: "DerÄ«gs CorobFlex (500,520,540)=iepriekÅ¡ Lenteq. HLD jÄbÅ«t instalÄtam. Tikai Windows"
            },
            corobNextDriver: {
                machineType:
                    "DerÄ«gs paaudzei Slave (D200, D600..), 4G (First One) un 5G (EvoFlx). JÄbÅ«t instalÄtam NextDriver. Tikai Linux"
            },
            dromontDDrv: {
                databasePath: "MarÅ¡ruts datu bÄzei ar kalibrÄÅ¡anas datiem. NoklusÄjuma iestatÄ«jumi",
                driverPath: "MarÅ¡ruts draiverim (D_DRV.exe). NoklusÄjuma iestatÄ«jumi",
                machineType:
                    "NetieÅ¡Ä komunikÄcija ar dozatoru caur iestatÄ«tajiem labojumiem. DerÄ«gs paaudzÄm V1 un V2. JÄbÅ«t instalÄtam D_SET. Gan Windows, gan Linux",
                resultPath: "MarÅ¡ruts gala failam, kas izveidots, kad operÄcija beigusies. NoklusÄjuma iestatÄ«jumi",
                serviceSoftwarePath: "MarÅ¡ruts Dromont servisa programmatÅ«rai (D_Set.exe). NoklusÄjuma iestatÄ«jumi"
            },
            dromontDirect: {
                machineType:
                    "TieÅ¡Ä komunikÄcija ar dozatoru. DerÄ«ga paaudzÄm V1 un V2. JÄbÅ«t instalÄtam D_SET. Gan Windows, gan Linux",
                rootDir: "IzvÄlieties galveno Dromont mapi. NoklusÄjuma iestatÄ«jumi"
            },
            dromontMisura: {
                driverPath:
                    "MarÅ¡ruts draverim (MisuraRetail.exe) varÄtu mainÄ«ties balstoties uz Misura Retail versiju. NoklusÄjuma iestatÄ«jumi.",
                extensionPath: "MarÅ¡ruts komunikÄciju failam servisa darbÄ«bÄm",
                formulaPath: "MarÅ¡ruts komunikÄciju failam dozÄÅ¡anai",
                machineType: "DerÄ«gs paaudzei V3. JÄbÅ«t instalÄtam Dromont Misura. Tikai Windows"
            },
            fastAndFluidIDD: {
                machineType: "DerÄ«gs visÄm F&F maÅ¡Ä«nÄm. Tikai Windows",
                path: "AtbalstÄ«ts tiek IDD2 (HA450, HA650, X-Smart utt.) -nepiecieÅ¡ama licence, IDD3 (HP 500 utml.) IDD4 (HA180, HA480, HA680, Xprotint utml.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "DerÄ«gs visÄm F&F maÅ¡Ä«nÄm. Gan Windows, gan Linux",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "DerÄ«gs visÄm Hero maÅ¡Ä«nÄm.Tikai Windows"
            },
            italtinto: {
                machineType: "DerÄ«gs visÄm Italtinto maÅ¡Ä«nÄm. JÄbÅ«t instalÄtam Wcal vai ItaltintoCal. Tikai Windows",
                path: "MarÅ¡ruts piemÄrotam ItaltintokonfigurÄcijas failam"
            },
            manualAdvanced: {
                machineType: "DerÄ«gs visÄm manuÄlajÄm maÅ¡Ä«nÄm, kolbu atbalsts iekÄ¼auts. Gan Windows, gan Linux",
                path: "MarÅ¡ruts konfigurÄcijas failam ar informÄciju par dozatoru un kolbÄm"
            },
            manualSimple: {
                machineType: "DerÄ«gs visÄm manuÄlajÄm maÅ¡Ä«nÄm. Gan Windows, gan Linux",
                path: "MarÅ¡ruts visÄm manuÄlajÄm maÅ¡Ä«nÄm ar informÄciju par dozatoru"
            },
            none: {
                machineType: "No dispenser driver is selected."
            },
            santintColorLink3: {
                machineType: "DerÄ«gs visÄm Santint maÅ¡Ä«nÄm. Tikai Windows"
            },
            simulation: {
                machineType: "DerÄ«gs dozatora simulÄcijai, ja reÄls dozators nav pieslÄgts datoram",
                path: "MarÅ¡ruts simulÄcijas konfigurÄcijas failam, kam jÄbÅ«t saskaÅÄ ar pievienoto datu bÄzi "
            },
            udcp: {
                machineType: "UDCP dispenser"
            }
        },
        environment: {
            activeServerPlugins: "The overview of additional software plugins.",
            allowAutoCloseTab:
                "With the setting on, each formula tab will be closed automatically after the dispensing process has been finished.",
            allowAutomaticClientStart: "AtÄ¼aut startÄt %{name} automÄtiski pÄc datora startÄÅ¡anas",
            allowAutomaticPrint:
                "UzlÄ«me tiks izdrukÄta automÄtiski. PieprasÄ«ti papildus iestatÄ«jumi drukÄt pirms vai pÄc, vai vienlaicÄ«gi ar dozÄÅ¡anu.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "ReceptÅ«ras kartÄ tiks aktivÄta klienta sekcija",
            allowDispensing: "ReceptÅ«ras kartÄ tiks aktivÄta dozÄÅ¡anas ikona",
            allowFileTransfer: "With this setting on, automatic data import and export by file transfer is available.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "On Formula Panel, Status panel will be activated.",
            allowLight: "%{name} bÅ«s pieejams",
            allowOrdering: "ReceptÅ«ras kartÄ tiks aktivÄta pasÅ«tÄ«juma ikona",
            allowPricing:
                "ReceptÅ«ras panelis, cenas var tikt lietotas. Cenu redzamÄ«ba ir iestatÄ«ta PieejamajÄs cenÄs. Cenas ir ievadÄ«tas Cenu iestatÄ«jumos",
            allowProductPreviewImage: "DozÄÅ¡anas laikÄ tiks parÄdÄ«ts produkta priekÅ¡skatÄ«jums",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "On Formula Panel, the function to search for cheaper colors will be available.",
            allowSoundNotification: "SaÅemot pasÅ«tÄ«jumu tiks atskaÅots skaÅas signÄls",
            allowSpectro: "Tiks aktivÄta spektrometra ikona",
            allowTabs: "With this setting on, working with multiple tabs simultaneously is available.",
            applyZoom: "IzÅ¡Ä·irtspÄjas palielinÄjums vai samazinÄjums. Darbojas arÄ« ar Ä«sceÄ¼iem Ctrl+ un Ctlr-",
            automaticLogout: "Set after how many minutes the automatic logout should be activated.",
            availableDatabases: "IestatÄ«jumi atÄ¼auj pÄrslÄgties starp datu bÄzÄm, ja ir vairÄk kÄ viena datu bÄze",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "SvÄ«trukodu testÄÅ¡anas vide piedÄvÄ pÄrbaudÄ«t skanÄto svÄ«trukodu pareizÄ«bu salÄ«dzinot tos ar svÄ«trukodiem, kas ievadÄ«ti datu bÄzÄ.",
            customBanner: "Iestatiet savu logotipu vai baneri un tÄ pozÄ«ciju",
            customCurrencyFormat:
                "Custom currency format can override default currency format based on selected language. ",
            customDateFormat: "Custom date format can override default date format based on selected language.",
            customNumberFormat: "Custom numer format can override default numer format based on selected language.",
            customTimeFormat: "Custom time format can override default time format based on selected language.",
            defaultPrinter: "Printeris pÄc noklusÄjuma",
            defaultTemplate: "UzlÄ«me pÄc noklusÄjuma",
            deleteImportedData: "NodzÄÅ¡ iepriekÅ¡ importÄtos datus. Dati var tikt atkal importÄti pÄc izdzÄÅ¡anas",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "Uz receptÅ«ras kartes iespÄjamas dozÄÅ¡anas piezÄ«mes",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "AtÄ¼aut virtuÄlo tastatÅ«ru %{name}",
            exportLocalSettings: "Exports the local settings of this computer.",
            exportStaticSql:
                "Exports the local settings of this computer. The exported file can be used to create a database with this setup.",
            exportTranslationKeys:
                "Export the newest translations and after translating, send them by email to your software supplier to have them imported.",
            favoriteButton: "Click to add the formula as favorite",
            formulaNotes: "Uz receptÅ«ras kartes iespÄjamas receptÅ«ras piezÄ«mes",
            helpSettings: "PalÄ«dzÄ«bas iestatÄ«jumi ÄtrajÄ izvÄlnÄ",
            importCustomData: "ImportÄ vietÄjos individuÄlos datus balstoties uz izvÄlÄto formÄtu",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Imports the local settings of this computer.",
            internalNote: "On Formula panel, internal note section will be accessible.",
            lockComputer:
                "IestatÄ«jumiÂ nodroÅ¡ina,Â kaÂ nevarÂ atstÄtÂ %{name}Â vidiÂ -Â tasÂ Ä¼aujÂ izmantotÂ maksimÄloÂ kioskaÂ reÅ¾Ä«maÂ pieredzi.Â AttiecasÂ tikaiÂ uzÂ Windows.",
            maxNumberTabs: "MaksimÄlais vienlaicÄ«gi atvÄrto receptÅ«ras karÅ¡u daudzums",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing: "EtiÄ·eÅ¡u skaits pÄc dozÄÅ¡anas",
            printAsImage: "DrukÄt kÄ attÄlu",
            printBeforeDispensing: "EtiÄ·eÅ¡u skaits pirms dozÄÅ¡anas",
            printEnabled:
                "This setting enables using printer with the software. Additional settings are in Print Settings.",
            printOnRequest: "Uz receptÅ«ras kartes tiks aktivizÄta drukas ikona ",
            printTaskVariable: "The print task is processed only if given print variable is available in print data",
            quickTintTemplate: "IzvÄlÄtÄs etiÄ·eÅ¡u sagataves tiks pielietotas aizpildot tÄs manuÄli",
            restoreLocalSettings: "Restores the local settings of this computer.",
            runLightAtStartUp: "%{light} tiks startÄts %{name} vietÄ",
            screenSaverTimeout: "Set after how many minutes, the screensaver should be activated.",
            selectCustomDataFormat:
                "IzvÄlÄties importÄjamo oriÄ£inÄlo datu formÄtu. Katram formÄtam var bÅ«t nepiecieÅ¡ami daÅ¾Ädi papildus dati un iestatÄ«jumi",
            setCustomHomeButton: "MÄjas ikona %{name} novedÄ«s uz izvÄlÄto paneli",
            setFts: "Pilna teksta meklÄÅ¡ana atÄ¼auj meklÄt pÄc teksta fragmentiem",
            setKeyboardShortcuts: "Nav iespÄjams pielietot vienu un to paÅ¡u taustiÅu kombinÄciju daÅ¾ÄdÄm darbÄ«bÄm ",
            setNumberOfDecimalPlaces: "NoapaÄ¼ojums norÄda cik decimÄldaÄ¼u tiks norÄdÄ«ts pigmentu daudzumam ",
            setOrderSearchParameters:
                "PasÅ«tÄ«jumu meklÄÅ¡ana definÄ kÄdi parametri tiks izmantoti meklÄjot starp pasÅ«tÄ«jumiem. Pieejams tikai %{name}",
            setOverwriteLastTab:
                "When choosing a new formula via global search whereas formula tab limit is reached, the last loaded formula tab will be overwritten by the new formula selection.",
            setSearchPanel: "IestatÄ«t individuÄlo redzamÄ«bu un parÄdÄ«Å¡anÄs kÄrtÄ«bu pie receptÅ«ras meklÄÅ¡anas ",
            setVisibilityAndOrder:
                "IzvÄlÄtie navigÄcijas elementi ir redzami ÄtrajÄ izvÄlÄ. AugstÄkÄ pozÄ«cija atrodas kreisajÄ pusÄ. MaksimÄlo navigÄcijas elementu daudzums ir 6.",
            setYourLanguage: "Valodas maiÅai nepiecieÅ¡ams pÄrstartÄt programmu",
            settingsSearch: "Look up various settings if you are unsure where to find them.",
            showNewOrderNotifications:
                "PasÅ«tÄ«jumu paziÅojums ir uzlecoÅ¡ais logs, kurÅ¡ dara zinÄmu jaunu pasÅ«tÄ«jumu saÅemÅ¡anu",
            sorting: "Kolbas var tikt Å¡Ä·irotas pÄc pigmentu nosaukuma vai pÄc kolbu ID",
            turnOnKioskMode: "Kioska logs nosedz izvÄlni",
            windowClosingRules:
                "IzvÄlne nosaka, vai manuÄlÄs dozÄÅ¡anas logs aizverÄs pirms vai pÄc dozÄÅ¡anas uzsÄkÅ¡anas"
        },
        formulaSettings: {
            additionalFormulaTab: "The setting decides which panel will be shown when opening a new formula tab.",
            allowCustomFormulas: "IndividuÄlo receptÅ«ru meklÄÅ¡ana un izveide tiek aktivizÄta",
            allowCustomPackageSize: "ReceptÅ«ras kartÄ tiek aktivizÄta nestandarta iepakojuma izvÄle",
            allowEditingColorants:
                "ReceptÅ«ras kartÄ tiek aktivizÄta iespÄja mainÄ«t receptÅ«ru. ParÄdÄs pÄc toÅa izvÄles",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Set size of base on Formula panel",
            bippPanelSize: "Set size of base in product package on Formula panel",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "ReceptÅ«ras kartÄ parÄdÄs krÄsas toÅa priekÅ¡skatÄ«jums",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "On Formula panel, the color preview will be represented by image.",
            colorPreviewResizable: "Allows to resize color preview panel.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formula panel can have the colorants ordered according to the names or by amounts.",
            customCanOption: "Choose which measurement units can be used for custom package size on Formula panel.",
            customCanSettingsUnit:
                "Choose which measurement unit can be used as default for custom package settings on Formula panel.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "IestatÄ«jums aktivÄ apstiprinÄjumu produkta pilnÄ«gai izdzÄÅ¡anai ",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Set size of fandeck on Formula panel",
            favoriteFormulasInitial: "StartÄjot %{name} parÄdÄ«sies favorÄ«tu panelis",
            formulaAutomaticNaming: "MainÄ«tajai receptÅ«rai mainot pigmentus automÄtiski parÄdÄs nosaukuma maiÅa",
            formulaPanel: "Atverot jaunu karti parÄdÄs receptÅ«ru panelis",
            formulaPanelInitial: "StartÄjot %{name} parÄdÄ«sies receptÅ«ru panelis",
            formulaPanelSize: "Set size of color on Formula panel",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "With this setting on, the color preview will be generated automatically. The resulting preview is not accurate.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "ReceptÅ«ras kartÄ blakus toÅa attÄlam parÄdÄ«sies arÄ« produkta attÄls, kÄ arÄ« iespÄja attÄlot vairÄk informÄcijas",
            images: "The setting defines the source of image files.",
            infoPanelResizable: "Allows to resize more info panel.",
            initialFormulaTab: "The setting decides which panel will be shown after %{0} starts.",
            moreInfo: "ReceptÅ«ras kartÄ blakus informÄcijas panelim parÄdÄ«sies arÄ« produkta attÄls, kÄ arÄ« toÅa attÄls",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "The setting enables to use product codes along with product names if available in the database.",
            productFiles: "The setting defines the source of product files which are available on Formula panel.",
            productGroups: "The setting enables hierarchy with product groups if available in the database.",
            productPanelSize: "Set size of product on Formula panel",
            searchNewFormula:
                "Atverot jaunu karti parÄdÄs receptÅ«ru meklÄÅ¡anas panelis (satur informÄciju par pÄdÄjÄm un favorÄ«tu receptÅ«rÄm)",
            searchNewFormulaInitial:
                "StartÄjot %{name} parÄdÄs receptÅ«ru meklÄÅ¡anas panelis (satur informÄciju par pÄdÄjÄm un favorÄ«tu receptÅ«rÄm)",
            searchPanelFormulaItems: "At least one of the formula items must be selected.",
            searchPanelProductItems: "Only one of the product items can be selected.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "With this setting on, the feature of competitive color search in Color Palette and Formula panel (only for not available formulas) is available.",
            setFormulaInfoInPreview:
                "On Formula panel, the selected data type will be always visible in the color preview.",
            setFormulaPreview:
                "The setting changes the position and display of color preview, package image and info data about the color.",
            setFormulaRGBPreviewVisibleInformation:
                "ReceptÅ«ras kartÄ vienmÄr pie toÅa attÄla redzams izvÄlÄtais datu tips",
            setFormulaUnit: "ReceptÅ«ras kartÄ pirmÄ tiek atvÄrta izvÄlÄtÄ mÄrvienÄ«ba. Pielietojama arÄ« manuÄli dozÄjot",
            setFormulaVisibilityAndOrder:
                "ReceptÅ«ras kartÄ izvÄlÄtais datu tips redzams sadaÄ¼Ä vairÄk info. (piemÄrojas, ja priekÅ¡skatÄ«jumu izvÄlnÄ ir iestatÄ«ti  vairÄk info vai toÅa attÄls)",
            setMaxToleranceForCompetitiveColors:
                "IestatÄ«t maksimÄlo Delta E (CIE 2000) toleranci salÄ«dzinoÅ¡ajai krÄsu meklÄÅ¡anai",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit: "ReceptÅ«ras kartÄ parÄdÄs izvÄlÄtÄs mÄrvienÄ«bas. PiemÄrojas arÄ« manuÄlai dozÄÅ¡anai",
            showColorPreview: "ReceptÅ«ras kartÄ meklÄÅ¡anas laikÄ parÄdÄs neliels krÄsu toÅa priekÅ¡skatÄ«jums",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Sum of colorant amounts is below base limit.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "The minimal tintable amount is the smallest colorant amount which can be dispensed as recommended by the laboratory.",
            checkOverfill:
                "The setting checks if there is enough space in the can for the colorants immediately after the amounts are set.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Colorant amount is below the minimal tintable amount.",
            dispensingWithErrorsEnabled:
                "If allowed, a warning message will appear in case of validation violations, but it will be possible to proceed to dispensing nonetheless.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Sum of colorant amounts is over maximal tintable amount.",
            overfill: "Overfill has been detected.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "I know the risks, continue"
        },
        help: "PalÄ«dzÄ«ba",
        helpLink: "PalÄ«dzÄ«bas centrs",
        helper: {
            automaticallyCheckForUpdates:
                "Tiks automÄtiski pÄrbaudÄ«ts vai ir pieejams atjauninÄjums priekÅ¡ %{name} vai datu bÄze noteiktajÄ laika intervÄlÄ",
            automaticallyDownloadUpdates:
                "Ja atjauninÄjums ir pieejams, tas tiks bez aptiprinÄÅ¡anas automÄtiski lejuplÄdÄts ",
            automaticallyInstallNewDatabases:
                "Ja lÄ«dz Å¡im nav nosÅ«tÄ«ts DB, tas tiks instalÄts kÄ jauns DB. PÄc tam DB var izmantot.",
            automaticallyInstallUpdates:
                "Ja atjauninÄjums ir lejuplÄdÄts, tas tiks bez apstiprinÄÅ¡anas automÄtiski instalÄts",
            canBrowseChangeLog: "AtjauninÄÅ¡anas laikÄ oficiÄlais %{name} izmaiÅu logs bÅ«s pieejams apskatei",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "AtjauninÄjums tiks instalÄts nakts laikÄ, ja dators bÅ«s ieslÄgts"
        },
        licensing: {
            collect:
                "The logfiles will be downloaded to the selected location. The logfiles are required by the software supplied for bug analysis.",
            company: "The company which supplied the license.",
            computerID: "License identification to help the software supplier in case of required assistance.",
            email: "The email address of the license holder.",
            licenseUuid: "License identification to help the software supplier in case of required assistance.",
            name: "The name of the license holder.",
            openBugreport:
                "Please let us know if there is a bug in the software and send us a report with the bug description.",
            posInfoContactperson: "POS information about the owner to be printed on the label.",
            posInfoMachineInformation:
                "POS information about the dispenser to be printed on the label or recognized in the network.",
            posInfoPos: "POS information about the location to be printed on the label.",
            reactivation: "Reactivation or change of the current license.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registration information to identify the owner of the license.",
            registrationMachineInformation: "Registration information to identify the dispenser of the license.",
            registrationPos: "Registration information to identify the location of the license.",
            versionScope: "The software expiration limits.",
            versionType: "The software product type."
        },
        machineIsBusy: "KÄ¼Å«dasÂ nevarÂ atiestatÄ«t,Â joÂ iekÄrtaÂ irÂ aizÅemta.",
        machineSettings: {
            allowManualColorantAddition:
                "Ja nepiecieÅ¡amais pigmentu daudzums pÄrsniedz maksimÄli iespÄjamo dozÄÅ¡anas daudzumu, ar Å¡o iestatÄ«jumu iespÄjams pÄc dozÄÅ¡anas manuÄli papildinÄt dozÄÅ¡anas devas",
            autotasks:
                "Autotasks ir automÄtiski maÅ¡Ä«nas un datora iestatÄ«jumi, kas izpildÄs noteiktÄ laikÄ vai noteiktÄ laika intervÄlÄ",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "The barcode is assigned to the canister in which the colorant is available. The barcode is necessary to ensure correct colorant refilling.",
            checkCanBeforeDispense: "IestatÄ«jums tikai Fast un Fluid simulÄcijai",
            checkOverfill: "IestatÄ«jums pÄrbauda, vai iepakojumÄ pietiek vietas pigmentiem",
            currentlySelectedMachine: "Provides information about the currently selected machine.",
            dispenseInvalidColorants:
                "Å is iestatÄ«jums atÄ¼auj dozÄt pigmentus, kuri nav definÄti maÅ¡Ä«nas konfigurÄcijÄ, piedÄvÄjot  manuÄlu pigmentu pievienoÅ¡anu",
            dispenserConfigurationBackup: "Download and save the current machine configuration to maintain a backup.",
            dispensingLogic:
                "Dispensing logic types can ensure different behaviour for each canisters when there is more colorant to be dispensed than allowed or desired. Additional behavior is set in Dispensing Settings.",
            enableTmc: "IestatÄ«jums datu sÅ«tÄ«Å¡anai uz TMC",
            enableUserIdentification: "User has to log in before dispensing is allowed.",
            machineUnit: "MaÅ¡Ä«nas mÄrvienÄ«bas = pigmentu mÄrvienÄ«bas",
            minDispensedAmount:
                "MinimÄlais dozÄÅ¡anas daudzums, nosaka cik daudz pigmenta jÄdozÄ, lai sprauslas tiktu uzskatÄ«tas par tÄ«rÄm un izvairÄ«tos no nevajadzÄ«gas skaloÅ¡anas",
            minimalDispenseAmount:
                "MinimÄlais dozÄÅ¡anas tilpums, kas nosaka, cik ir mazÄkais dozÄÅ¡anas tilpums. PÄrsniedzot to parÄdÄs paziÅojums (dozÄÅ¡ana tiek pieÄ¼auta).",
            missingAutotaskCanisters: "JÄbÅ«t izvÄlÄtai vismaz vienai kolbai",
            missingAutotaskChannels: "JÄbÅ«t izvÄlÄtam vismaz 1 kanÄlam",
            missingAutotaskChannelsValue: "Visiem izvÄlÄtajiem kanÄliem jÄbÅ«t uzpildÄ«tiem",
            missingAutotaskCleanTime: "TÄ«rÄ«Å¡anas laikam jÄbÅ«t aizpildÄ«tam",
            missingAutotaskName: "AutomÄtisko darbÄ«bu nosaukumam jÄbÅ«t aizpildÄ«tam",
            missingAutotaskRecirculation: "RecirkulÄcijas laikam un Ätrumam jÄbÅ«t aizpildÄ«tam",
            missingAutotaskStirring: "MaisÄ«Å¡anas laikam un Ätrumam jÄbÅ«t aizpildÄ«tam",
            missingAutotaskVolume: "TÄ«rÄ«Å¡anas apjomam jÄbÅ«t aizpildÄ«tam",
            placeCanSensor:
                "IestatÄ«jums aktivizÄ iepakojuma sensoru, dozÄÅ¡ana iespÄjama tikai, kad iepakojums novietots dozÄÅ¡anas pozÄ«cijÄ.",
            placeCanSensorDelay:
                "Ieteicams iestatÄ«jums, kas ir saistÄ«bÄ ar iepakojuma sensoru. Nosaka laiku pÄc kÄda var tikt sÄkta dozÄÅ¡ana, kad iepakojums ir novietots pozÄ«cijÄ. ",
            purgeVolume:
                "TÄ«rÄ«Å¡anas tilpums, kas nosaka cik daudz pigmenta tiek dozÄts, lai sprauslu varÄtu tik uzskatÄ«tu par tÄ«ru inteliÄ£entajÄ skaloÅ¡anÄ.",
            rccUrl: "Redlike Control Center (RCC) is responsible for the communication with the dispenser.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "IestatÄ«jums aktivizÄ iepakojuma sensoru, kad dozÄÅ¡ana ir pabeigta un iepakojums ir noÅemts no dozÄÅ¡anas pozÄ«cijas.",
            removeCanSensorDelay:
                "Ieteicams iestatÄ«jums, kas ir saistÄ«bÄ ar iepakojuma sensoru. Nosaka laiku pÄc kÄda dozÄÅ¡ana var tikt uzskatÄ«ta par pabeigtu un iepakojums var tikt noÅemts no dozÄÅ¡anas pozÄ«cijas. ",
            skipPlaceCanDialog:
                "Å is iestatÄ«jums nosaka, ka novietojot iepakojumu dozÄÅ¡anas pozÄ«cijÄ, dozÄÅ¡ana sÄkas automÄtiski, nenospieÅ¾ot OK pogu.",
            skipRemoveCanDialog:
                "Å is iestatÄ«jums nosaka, dozÄÅ¡ana ir notikusi, kad iepakojums ir noÅemts no dozÄÅ¡anas pozÄ«cijas, nenospieÅ¾ot OK pogu.",
            smartPurgeType:
                "TÄ«rÄ«Å¡anas tips nosaka Åemt vÄrÄ tikai dozÄÅ¡anu vai dozÄÅ¡anu un citas darbÄ«bas, lai definÄtu inteliÄ£ento  tÄ«rÄ«Å¡anu.",
            splitFormula:
                "Kad nepiecieÅ¡amais pigmenta daudzums pÄrsniedz maksimÄlo iespÄjamo daudzumu, iestatÄ«jums pieÄ¼auj veikt daÄ¼Äju dozÄÅ¡anu, pÄc pigmentu uzpildes turpinot dozÄÅ¡anu.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "BÄzes iepakojums jÄapstiprina ar svÄ«trukoda noskanÄÅ¡anu, lai pÄrliecinÄtos par pareizÄs bÄzes izvÄli. ",
            validateColorantsDuringInit:
                "The machine configuration will be compared to the database each time when RCC is restarted. In case of mismatches, a notification occurs."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opens a window with the possibility to enter the barcode manually.",
            canisterBarcodes: "Atver logu ar kolbu svÄ«trukodiem un iespÄju ievadÄ«t svÄ«trukodus",
            canisterLevel: "Atver logu ar kolbu uzpildes lÄ«meÅiem un iespÄju tos iestatÄ«t/mainÄ«t",
            canisters: "Atver paneli ar kolbu uzpildes lÄ«meÅu pÄrskatu un iespÄju tos izmainÄ«t",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Atver paneli ar iespÄju meklÄt jaunu receptÅ«ru pÄc elektoniskÄs krÄsu paletes",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Atver logu ar pÄrskatu par veiktajÄm kolbu uzpildÄ«Å¡anÄm",
            customFormula: "Atver paneli ar iespÄju izveidot jaunu individuÄlo receptÅ«ru.",
            customers: "Atver paneli ar klientu pÄrskatu un iespÄju to koriÄ£Ät/papildinÄt/dzÄst",
            dispensingHistory: "Atver paneli ar veikto dozÄÅ¡anu pÄrskatu.",
            favorites: "Atver paneli ar iespÄju izvÄlÄties mÄ«Ä¼Äko receptÅ«ru",
            help: "Atver paneli ar klientu servisa informÄciju, ja tÄda ir nodroÅ¡inÄta",
            hideItems: "Opens a window with the possibility to mark products and fandecks as hidden.",
            historyOfOrders: "DerÄ«gs tika priekÅ¡ %{name}, atver paneli ar veikto pasÅ«tÄ«jumu dozÄÅ¡anas pÄrskatu",
            machineReset: "SÄk maÅ¡Ä«nas pÄrstartÄÅ¡anu",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "PasÅ«tÄ«jumi, kas nosÅ«tÄ«ti no Å¡Ä« datora",
            purge: "Atver logu ar iespÄju iestatÄ«t sprauslu skaloÅ¡anu",
            quickTint: "Atver logu ar iespÄju dozÄt manuÄli",
            searchFormula: "Atver paneli ar iespÄju meklÄt jaunu receptÅ«ru ",
            spectro: "Atver paneli ar iespÄju mÄrÄ«t ar spektrometru",
            stir: "Atver logu ar iespÄju iestatÄ«t maisÄ«Å¡anu kolbÄs",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "PasÅ«tÄ«jumi, kas saÅemti no Å¡Ä« datora"
        },
        noHelpForLicense: "Nav pieejama palÄ«dzÄ«ba pÄc jÅ«su licences, lÅ«dzam griezties pie jÅ«su piegÄdÄtÄja",
        posInfo: {
            sync: "SinhronizÄ datus ar reÄ£istrÄcijas nodaÄ¼u"
        },
        poweredByDeso: "RadÄ«ts %{name}",
        priceSettings: {
            VatPrice: "PVN pigmentiem, %",
            VatPriceProduct: "The generic product VAT will be the same for every colorant. Set in %.",
            basePurchase: "Iepirkuma cena bÄzei",
            basePurchasePriceProduct: "Purchase price for the package of the given base. Set in selected currency.",
            baseSell: "PÄrdoÅ¡anas cena bÄzei (iekÄ¼auj bÄzes cenu un uzcenojumu)",
            baseSellFull: "Sell full price for base.",
            cntName: "Defines which colorant the price is related to.",
            cntPurchase: "Iepirkuma cena pigmentiem (tikai pigmentiem)",
            cntPurchaseByName: "Iepirkuma cena katram atseviÅ¡Ä·am pigmentam",
            cntPurchasePricePerLiter: "Iepirkuma cena pigmentam par litru (bez uzcenojuma)",
            cntSell: "PÄrdoÅ¡anas cena pigmentam (iekÄ¼auj iepirkuma cenu un uzcenojumu)",
            cntSellByName: "IndividuÄla pÄrdoÅ¡anas cena visiem pigmentiem (iekÄ¼auj iepirkuma cenu un uzcenojumu)",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "The sell price of the colorant per liter (incl. colorant exclusively). Set in the selected currency.",
            cntVat: "Colorant VAT value set in %.",
            colorants: "Visiem pigmentiem vienÄdas cenas. Å Ä« funkcija izmantojama piemÄrojot cenai PVN",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "ValÅ«tas kods (3 burti, piem. EUR)",
            currencyNameNew: "ValÅ«tas nosaukums, piem. eiro",
            currencyRateNew: "ValÅ«tas kurss pret pamatvalÅ«tu, piem. 25.855CZK par 1 EUR. Kurss jÄmaina manuÄli.",
            currencyRoundingNew:
                "NoapaÄ¼ojums nosaka, kÄda mazÄkÄ naudas vienÄ«ba uzrÄdÄs. Piem eiro tas ir 0.01 EUR, jeb 1 cents",
            currencySymbolNew: "OficiÄlais valÅ«tas simbols, piem. â¬",
            defaultPrice: "NoteiktÄ pigmenta cena no datu bÄzes (bez PVN)",
            defaultPriceGroup: "Pigmenta cena no datu bÄzÄ noteiktÄs cenu grupas (bez PVN)",
            defaultVatPrice: "Datu bÄzÄ noteiktÄ PVN vÄrtÄ«ba",
            discountHeader: "Discount substracts the the defined value from the purchase colorant price. Set in %.",
            discountHeaderProduct:
                "Discount substracts the the defined value from the product colorant price. Set in %.",
            export: "Export a file with the currently inserted prices. It can be imported again after having modified the prices.",
            import: "Import a correctly formated (exported) file to insert or modify the prices.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Choose which price calculation should be used for the definition of the final available price. Margin and markup add up to whereas discount substracts from the given sell price.",
            marginAll: "Cena vairÄkiem iepakojumiem (Uzcenojums/marÅ¾a iekÄ¼auts)",
            marginHeader: "Margin adds the defined value up to the purchase colorant price. Set in %.",
            marginHeaderProduct: "Margin adds the defined value up to the purchase product price. Set in %.",
            marginPerPkg: "Cena vienam iepakojumam (Uzcenojums/marÅ¾a iekÄ¼auts)",
            markupHeader: "Markup adds the defined value up to the purchase colorant price. Set in %.",
            markupHeaderProduct: "Markup adds the defined value up to the purchase product price. Set in %.",
            packagePricing: "Papildus uzcenojums (minimÄlÄ cena) katram iepakojumam individuÄli",
            packageSurcharge: "VisÄm iepakojumu cenÄm vienÄds uzcenojums (minimÄlÄ cena)",
            priceDefinition: "The setting defines which price types are used when calculating final prices.",
            priceGroupNumber:
                "The setting defines how many price groups will be used. The range for individual price groups can be set in Default Values.",
            priceGroupPricePerLiter: "Pigmenta cena, kas tiek noteikta aprÄÄ·inot cenu grupu cenas",
            priceGroups:
                "Tiek uzrÄdÄ«ts cenu grupas numurs (RobeÅ¾as tiek noteiktas caur datu bÄzi vai pie vispÄrÄ«gÄs cenu ievades.  ",
            priceGroupsEnabled:
                "The setting allows you to work with price groups. Define the range in Default Values and individual prices in Colorant Pricing.",
            priceGroupsGeneric: "Cenu grupas ir cenu intervÄli, kas balstÄ«ti uz pigmentu cenu receptÅ«rÄ",
            productBasePackageSellPrice: "Sell price for the package of the given base. Set in selected currency.",
            productBaseSellPrice:
                "Sell price for base calculated per liter (incl. base exclusively). Set in the selected currency.",
            productBaseVat: "Product base VAT value for the given package set in %.",
            productName: "Defines which product base the price is related to.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "PÄrdoÅ¡anas cena visiem iepakojumiem tiek ievadÄ«ta manuÄli",
            productSize: "Defines which package of the given product base the price is related to.",
            productVat: "Product base VAT value set in %.",
            products:
                "VispÄrÄjÄs produktu cenas ir vienÄdas visiem produktiem. Å Ä« funkcija ir noderÄ«ga iestatot PVN vÄrtÄ«bu",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "PÄrdoÅ¡anas cena vairÄkiem iepakojumiem (iekÄ¼aujot bÄzes un pigmentu cenu, kÄ arÄ« visus uzcenojumus)",
            sellPricePerKg:
                "PÄrdoÅ¡anas cena par kilogramu (iekÄ¼aujot bÄzes un pigmentu cenu, kÄ arÄ« visus uzcenojumus)",
            sellPricePerL: "PÄrdoÅ¡anas cena par litru (iekÄ¼aujot bÄzes un pigmentu cenu, kÄ arÄ« visus uzcenojumus)",
            sellPricePerPkg:
                "PÄrdoÅ¡anas cena par vienu iepakojumu (iekÄ¼aujot bÄzes un pigmentu cenu, kÄ arÄ« visus uzcenojumus)",
            setPriceTypesVisibilityAndOrder:
                "RecepÅ¡u kartÄ tiek uzrÄdÄ«ti izvÄlÄtie cenu tipi. AugstÄkÄ pozÄ«cija parÄdÄs no kreisÄs puses cenu segmentÄ.",
            surchargeAll: "VÄrtÄ«ba fiksÄtajai minimÄlajai cenai par vairÄkiem iepakojumiem",
            surchargePerPkg: "VÄrtÄ«ba fiksÄtajai minimÄlajai cenai par vienu iepakojumu",
            tintPurchaseAll:
                "PÄrdoÅ¡anas cena visam tonÄÅ¡anas procesam vairÄkiem iepakojumiem (ieskaitot pigmentus un fiksÄto cenu)",
            tintPurchasePerPkg:
                "PÄrdoÅ¡anas cena visam tonÄÅ¡anas procesam vienam iepakojumam (ieskaitot pigmentus un fiksÄto cenu)",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "KopÄjÄ pÄrdoÅ¡anas cena produktam vairÄkiem iepakojumiem (ieskaitot bÄzi un pigmentus)",
            totalPurchasePerKg: "KopÄjÄ pÄrdoÅ¡anas cena produktam par kilogramu (ieskaitot bÄzi un pigmentus)",
            totalPurchasePerL: "KopÄjÄ pÄrdoÅ¡anas cena produktam par litru (ieskaitot bÄzi un pigmentus)",
            totalPurchasePerPkg: "KopÄjÄ pÄrdoÅ¡anas cena produktam par vienu iepakojumu (ieskaitot bÄzi un pigmentus)",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat: "Uz receptÅ«ras paneÄ¼a bÅ«s redzama cena abÄs versijÄs vienlaicÄ«gi, gan ar, gan bez PVN",
            withVat: "Uz receptÅ«ras paneÄ¼a bÅ«s redzama cena tikai ar PVN",
            withoutVat: "Uz receptÅ«ras paneÄ¼a bÅ«s redzama cena tikai bez PVN"
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "SinhronizÄ datus ar POS nodaÄ¼u"
        },
        searchingPleaseWait: "Please wait, the best match is being searched for",
        setupSteps: {
            customData: "Custom Data",
            machineType: "Machine Type",
            userPreferences: "User Preferences"
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "When using profiled values, the measured results are recalculated to remove the filter effect. Allow this option for universal spectro measuring.",
            XRiteModelRM400: "No drivers required.",
            datacolorDiagnosticTile: "Datacolor use diagnostic tile",
            datacolorSilent: "Datacolor silent",
            measureModes: "Select supported gloss levels.",
            model: "Model",
            simulationPath: "Path to the simulation file. Default preset.",
            spectroType: "Official spectro driver has to be installed. Windows only.",
            spectroTypeCom:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeDataColorReader:
                "The computer has to have Bluetooth connection. The spectro has to be paired with the computer. Windows 10 with 2018 automn update required.",
            spectroTypeMinolta2XXXd:
                "Official spectro driver has to be installed. Beware of the used COM Port. Windows as well as Linux.",
            spectroTypeNotSelected: "Select your spectro model.",
            spectroTypeRM400: "No drivers required.",
            spectroTypeSimulation: "Lab values required to obtain simulation results. Windows as well as Linux.",
            spectroTypeXRite: "Windows only."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI code has to be validated via barcode before dispensing is allowed.",
            enableUfiCodes:
                "UFI codes are used in EU and provide information about how hazardous a product is to environment.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label.",
            printUfiCodePercentage:
                "If a colorant in a formula exceeds the given limit, its UFI code will be printed on the print label along with its percentage representation.",
            ufiCodesByPercentage:
                "The UFI code which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            ufiCodesFromDatabase:
                "The UFI code from the main database given by the database administrator is used for printing.",
            ufiCodesFromLastFilling:
                "The UFI code from the last refill given by the operator is used for printing regardless the refilled amount."
        },
        userManagement: {
            add: "The setting adds a new user who can log in into the software. The user can have a barcode assigned and can be set to log in automatically after the software is started.",
            assignedGroups:
                "This defines what user groups the user belongs to. Various user groups distribute various privileges.",
            availableGroups:
                "This defines what user groups there are available for the user. Various user groups distribute various privileges.",
            loggedUserDelete: "Currently logged in user cannot be deleted."
        },
        visit: "ApmeklÄjiet",
        visitNoLicense: "Lai iegÅ«tu vairÄk informÄcijas apmeklÄjiet"
    },
    helpSettings: {
        customHelpLink: "Saite uz palÄ«dzÄ«bas centru",
        helpSettings: "PalÄ«dzÄ«bas iestatÄ«jumi",
        message: "PaziÅojums"
    },
    helper: {
        automaticallyCheckForUpdates: "AutomÄtiski meklÄt atjauninÄjumus",
        automaticallyDownloadUpdates: "AutomÄtiski lejuplÄdÄt atjauninÄjumus",
        automaticallyInstallNewDatabases: "AutomÄtiski instalÄt jaunÄs datu bÄzes",
        automaticallyInstallUpdates: "AutomÄtiski instalÄt atjauninÄjumus",
        bugReport: "KÄ¼Å«du atskaite",
        canBrowseChangeLog: "ParÄdÄ«t onlainÄ %{name} izmaiÅu logu",
        collect: "Apkopot",
        collectLogFiles: "Apkopot pierakstÄ«Å¡anÄs failus",
        component: "Komponente",
        content: "Saturs",
        contentSize: "Saturs pÄc lieluma",
        download: "LejuplÄdÄt",
        downloadLogFiles: "lejuplÄdÄt pierakstÄ«Å¡nÄs arhÄ«vu",
        downloadingData: "Dati tiek lejuplÄdÄti",
        everyHours: "Katru %{interval} stundu",
        forceInstall: "Force to update",
        installDuringNight: "InstalÄt naktÄ« (23.00-05.00)",
        newVersion: "Jauna versija",
        notConnected: "Nav savienots",
        openBugReport: "AtvÄrt kÄ¼Å«du atskaiti",
        packageSize: "Iepakojums",
        pleaseWait: "LÅ«dzam uzgaidÄ«t",
        send: "NosÅ«tÄ«t",
        sendBugReportToCustomerService: "NosÅ«tÄ«t kÄ¼Å«du atskaiti klientu servisam",
        sendingReport: "Atskaite tiek sÅ«tÄ«ta",
        subject: "TÄma"
    },
    helperDialog: {
        1: "MeklÄt programmatÅ«ras un datu bÄzu atjauninÄjumus",
        2: "TurpinÄt ar atjauninÄjumu paketes jejuplÄdi?",
        3: "Vai turpinÄt ar lejuplÄdÄtÄs atjauninÄjumu paketes instalÄciju?",
        10: "Programmas un datu bÄzu aktualizÄcija, lÅ«dzu uzgaidietâ¦",
        11: "Ir pieejams atjauninÄjums jÅ«su datoram. Vai vÄlaties to lejuplÄdÄt?",
        12: "JÅ«su datoram nav pieejami atjauninÄjumi.",
        14: "MeklÄjot atjauninÄjumus ir radusies kÄ¼Å«da %{0}",
        15: "Zonu datu bÄzes tiek sinhronizÄtas, lÅ«dzam uzgaidÄ«tâ¦",
        20: "AtjauninÄjumi tiek lejuplÄdÄti, lÅ«dzam uzgaidÄ«tâ¦",
        21: "LejuplÄdÄtÄ atjauninÄjumu pakete tiek verificÄta, lÅ«dzam uzgaidÄ«tâ¦",
        22: "AtjauninÄjumu paketes lejupielÄde ir kÄ¼Å«daina, vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        23: "AtjauninÄjumu paketes lejupielÄde ir kÄ¼Å«daina (dati ir deformÄti), vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        24: "Vai turpinÄt ar atjauninÄjumu instalÄciju?",
        25: "AutomÄtisko atjauninÄjumu instalÄcija sÄksies %{0}",
        26: "Yra naujinys Å¡iam kompiuteriui. Ar norÄtumÄte jÄ¯ atsisiÅ³sti?",
        27: "TÄsti atnaujinimo diegimÄ?",
        40: "Programmas un pakalpojumi tiek apturÄti, lÅ«dzam gaidÄ«tâ¦",
        41: "Jaunie dati tiek kopÄti, lÅ«dzam gaidÄ«tâ¦",
        42: "Programmas un pakalpojumi tiek startÄti, lÅ«dzam gaidÄ«tâ¦",
        43: "Programmu atjauninÄÅ¡ana, lÅ«dzam gaidÄ«tâ¦",
        44: "JÅ«su programmas veiksmÄ«gi atjauninÄtas",
        45: "VÄlaties mÄÄ£inÄt vÄlreiz instalÄt? Ja izlÄmÄt mÄÄ£inÄt vÄlreiz, pÄrliecinieties, ka netiek izmantotas kÄdas patreizÄjÄs programmas komponentes.",
        46: "NepiecieÅ¡ama datora pÄrstartÄÅ¡ana, lai izmaiÅas sÄktu darboties. PÄrstartÄÅ¡ana sÄksies %{0}",
        999: "Radusies iekÅ¡Äja kÄ¼Å«da: %{0}",
        automaticInstallation: "AtjauninÄjumu automÄtiska instalÄcija",
        btnAbort: "PÄrtraukt",
        btnCancel: "Atcelt",
        btnCheckUpdate: "MeklÄt atjauninÄjumus",
        btnContinue: "TurpinÄt",
        btnDownloadUpdate: "LejuplÄdÄt atjauninÄjumus",
        btnInstallUpdate: "InstalÄt atjauninÄjumus",
        btnOk: "OK",
        btnRetry: "MÄÄ£inÄt vÄlreiz",
        btnSkip: "Izlaist  ",
        checkingForUpdates: "Tiek meklÄti atjauninÄjumi",
        downloadingFailed: "LejupielÄde neveiksmÄ«ga",
        downloadingPackage: "AtjauninÄjumu pakete tiek lejuplÄdÄta, lÅ«dzu uzgaidietâ¦",
        finishingUpdate: "AtjauninÄÅ¡ana tiek pabeigta",
        installingUpdate: "AtjauninÄÅ¡ana tiek instalÄta",
        internalError: "IekÅ¡Äja kÄ¼Å«da",
        rebootRequired: "NepiecieÅ¡ama pÄrstartÄÅ¡ana",
        startingComponents: "SÄkt programmas komponentes",
        stoppingComponents: "ApturÄt programmas komponentes",
        synchronizingDatabases: "ZonÄlo datu bÄzu sinhronizÄÅ¡ana",
        updateAvailable: "AtjauninÄjumi pieejami, atjauninÄmo komponenÅ¡u izvÄle",
        updateDownloaded: "AtjauninÄjumu pakete ir lejuplÄdÄta",
        updateFailed: "AtjauninÄjumu mÄÄ£inÄjums neveiksmÄ«gs",
        updateInstalled: "AtjauninÄjumu pakete tika instalÄta",
        verificationFailed: "Atjaunojumu paketes verifikÄcija neveiksmÄ«ga",
        verifyingPackage: "LejuplÄdÄtÄ atjauninÄjumu pakete tiek verificÄta",
        yourSoftwareIsUpToDate: "JÅ«su programmatÅ«rai ir jaunÄkÄ versija",
        yourSoftwareVersion: "JÅ«su programmatÅ«ras versija: %{0}"
    },
    importData: {
        abortImportingData: "Datu imports tiek pÄrtraukts",
        aborted: "Imports tika pÄrtraukts",
        backupLocalDB: "Backup local database",
        confirmRestore: "Do you really want to restore all local settings?",
        dataMissing: "ImportÄÅ¡ana neizdevÄs, jo avota failÄ nebija datu.",
        deleteImportedData: "DzÄst importÄtos datus",
        encodingFile: "Datu atkodÄÅ¡ana",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "ImportÄÅ¡ana neizdevÄs, jo avota fails Å¡Ä·iet ir bojÄts",
        fileMissing: "ImportÄÅ¡ana neizdevÄs, jo avota fails neeksistÄ",
        format: "FormÄts",
        formatPath: "FormÄta ielÄps",
        headerMissing: "ImportÄÅ¡ana neizdevÄs, jo failam nav nosaukuma",
        import: "Imports",
        importAborted: "Imports pÄrtraukts",
        importAborting: "Imports tiek pÄrtraukts",
        importFailed: "ImportÄÅ¡ana neizdevÄs, negaidÄ«ta kÄ¼Å«da",
        importLocalSettings: "Import Local Settings",
        importPrices: "ImportÄt cenas",
        imported: "VeiksmÄ«gi importÄts",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Tiek importÄts",
        noFormatAvailable: "FormÄts nav pieejams ",
        processing: "ApstrÄdÄ",
        processingCustomFormulas: "IndividuÄlÄs receptÅ«ras tiek apstrÄdÄtas",
        processingCustomers: "Klientu dati tiek apstrÄdÄti",
        productsFile: "Produktu dati",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Notiek datu importÄÅ¡ana",
        unknownFormat: "ImportÄÅ¡ana neizdevÄs, jo avota failam nezinÄms formÄts",
        userFormulasFile: "ReceptÅ«ru dati"
    },
    infoType: {
        baseDensity: "BÄzes blÄ«vums",
        baseMass: "BÄzes masa",
        baseUfiCode: "Base UFI code",
        baseVolume: "BÄzes tilpums",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS klase",
        colorLab: "KrÄsas Lab",
        colorRgb: "KrÄsas RGB",
        colorRgbHex: "KrÄsas RGB Hex",
        colorXyz: "KrÄsas xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Pigmentu svars",
        colorantUfiCodes: "Colorant UFI codes",
        colorantVolume: "Pigmentu tilpums",
        formulaDate: "Formula date",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formula more info",
        formulaMoreInfoInternal: "Formula more info internal",
        formulaMoreInfoPrint: "Formula more info print",
        hbw: "HBW-gaiÅ¡uma pakÄpe",
        isPackageGravimetric: "Ar pakuotÄ yra gravimetrinÄ",
        maxColorantMass: "MaksimÄli pieÄ¼aujamais pigmentu svars",
        maxColorantVolume: "MaksimÄli pieÄ¼aujamais pigmentu tilpums",
        nominalMass: "Iepakojuma nominÄlÄ masa",
        nominalVolume: "Iepakojuma nominÄlais tilpums",
        overfillDetected: "KonstatÄta pÄrpilde",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "KopÄjais krÄsas svars",
        totalPaintVolume: "KopÄjais krÄsas tilpums",
        ufiCodesTable: "UFI codes table",
        verifiedFormula: "Verified formula",
        yValue: "Y vÄrtÄ«ba"
    },
    initialTab: {
        favoriteFormulas: "FavorÄ«ti",
        lastDispensedFormulas: "PÄdÄjÄs dozÄtÄs receptÅ«ras",
        searchNewFormula: "MeklÄt jaunu receptÅ«ru"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "action",
        add: "add",
        addition: "addition",
        additional: "additional",
        address: "address",
        admin: "admin",
        advanced: "Advanced",
        after: "after",
        afterDispensing: "after dispensing",
        alfa: "Alfa",
        all: "all",
        allow: "allow",
        alphabetically: "alphabetically",
        amount: "amount",
        api: "api",
        ask: "ask",
        autocap: "autocap",
        autotask: "autotask",
        availablePrice: "available price",
        backup: "backup",
        banner: "banner",
        barcode: "barcode",
        barcodes: "barcodes",
        base: "base",
        before: "before",
        begin: "begin",
        bfs: "bfs",
        bottom: "bottom",
        brand: "brand",
        brush: "brush",
        bug: "bug",
        button: "button",
        buy: "buy",
        cC3: "CC3",
        cM: "CM",
        calibration: "calibration",
        can: "can",
        canHandling: "can handling",
        canister: "canister",
        canisterFilling: "canister filling",
        canisterLevels: "canister levels",
        canisters: "canisters",
        cap: "cap",
        center: "Center",
        centre: "Centre",
        change: "change",
        changelog: "changelog",
        channels: "channels",
        check: "check",
        chunk: "chunk",
        chunks: "chunks",
        city: "city",
        clean: "clean",
        cleaning: "cleaning",
        clientIdentifier: "client identifier",
        close: "close",
        closest: "closest",
        code: "code",
        collect: "collect",
        color: "color",
        colorLink3: "ColorLink3",
        colorPanel: "color palette",
        colorReader: "ColorReader",
        colorant: "colorant",
        colorantConsumption: "colorant consumption",
        colorantPrice: "colorant price",
        colorants: "colorants",
        colorix: "Colorix",
        colour: "colour",
        communication: "communication",
        compare: "compare",
        competitive: "competitive",
        computer: "computer",
        config: "config",
        configuration: "configuration",
        confirm: "confirm",
        confirmation: "confirmation",
        connection: "connection",
        contactPerson: "contact person",
        control: "Control",
        copies: "copies",
        corob: "Corob",
        cost: "cost",
        country: "country",
        create: "create",
        currency: "currency",
        current: "current",
        custom: "custom",
        customers: "customers",
        daily: "daily",
        dark: "Dark",
        data: "data",
        database: "database",
        datacolor: "Datacolor",
        date: "date",
        decimals: "decimals",
        default: "default",
        delay: "delay",
        delete: "delete",
        deletion: "deletion",
        deltaE: "delta e",
        device: "device",
        devices: "devices",
        diagnosticTile: "diagnostic tile",
        dialog: "dialog",
        direct: "direct",
        disconnect: "disconnect",
        discount: "discount",
        dispense: "dispense",
        dispenser: "dispenser",
        dispensing: "dispensing",
        down: "down",
        download: "download",
        driver: "driver",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "edit",
        editor: "editor",
        email: "email",
        error: "error",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "excel",
        expiration: "expiration",
        export: "export",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fandeck",
        fastFluid: "Fast & Fluid",
        file: "file",
        fill: "fill",
        fillToMax: "fill to max",
        find: "find",
        first: "first",
        flex: "Flex",
        folder: "folder",
        formula: "formula",
        formulas: "formulas",
        from: "from",
        fts5: "fts5",
        fullScreen: "full screen",
        fullText: "full-text",
        fulltext: "fulltext",
        g: "g",
        genericPricing: "generic pricing",
        hLD: "HLD",
        hard: "hard",
        hbw: "hbw",
        help: "help",
        helpCenter: "help center",
        hero: "Hero",
        history: "history",
        home: "home",
        host: "host",
        humidifier: "humidifier",
        iDD: "IDD",
        identification: "identification",
        image: "image",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "import",
        individually: "individually",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialization",
        initialize: "initialize",
        insert: "insert",
        install: "install",
        intellyPurge: "intelly purge",
        invalid: "invalid",
        ipAddress: "ip address",
        italtinto: "Italtinto",
        items: "items",
        keyboard: "keyboard",
        kg: "kg",
        kiosk: "kiosk",
        kioskMode: "kiosk mode",
        l: "l",
        lLD: "LLD",
        lab: "lab",
        label: "label",
        labels: "labels",
        language: "language",
        largo: "largo",
        last: "last",
        lenteq: "Lenteq",
        levels: "levels",
        license: "license",
        light: "Light",
        limit: "limit",
        link: "link",
        linux: "Linux",
        load: "load",
        lock: "lock",
        logFiles: "log files",
        logic: "logic",
        logo: "logo",
        lower: "lower",
        machine: "machine",
        machineConfiguration: "machine configuration",
        machineManagement: "machine management",
        machineName: "machine name",
        main: "main",
        maintenance: "maintenance",
        manual: "manual",
        manualAddition: "manual addition",
        manualDispensing: "manual dispensing",
        manualScan: "manual scan",
        margins: "margins",
        markups: "markups",
        mass: "mass",
        match: "match",
        measure: "measure",
        measurement: "measurement",
        measurementUnits: "measurement units",
        melody: "melody",
        message: "message",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minutes",
        misura: "Misura",
        ml: "ml",
        mode: "mode",
        model: "model",
        modification: "modification",
        modify: "modify",
        monthly: "monthly",
        moreInfo: "more info",
        movableTable: "movable table",
        move: "move",
        music: "music",
        myOrders: "my orders",
        name: "name",
        naming: "naming",
        nano: "Nano",
        navigation: "navigation",
        new: "new",
        nextDriver: "NextDriver",
        night: "night",
        nixPro: "Nix Pro",
        notes: "notes",
        notification: "notification",
        number: "number",
        off: "off",
        open: "open",
        order: "order",
        ordering: "ordering",
        overfill: "overfill",
        overview: "overview",
        overwrite: "overwrite",
        own: "own",
        pCPDriver: "PCPDriver",
        package: "package",
        packagePrice: "package price",
        packages: "packages",
        panels: "panels",
        parameter: "parameter",
        path: "path",
        pc: "pc",
        phone: "phone",
        phoneNumber: "phone number",
        picture: "picture",
        place: "place",
        placement: "placement",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "point of sale",
        popUp: "pop-up",
        pos: "pos",
        present: "present",
        preview: "preview",
        price: "price",
        priceExport: "price export",
        priceGroup: "price group",
        priceImport: "price import",
        prices: "prices",
        pricing: "pricing",
        primaryCurrency: "primary currency",
        print: "print",
        printer: "printer",
        printing: "printing",
        problem: "problem",
        product: "product",
        productPrice: "product price",
        profiledValues: "profiled values",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "purge",
        purgeType: "purge type",
        purgeVolume: "purge volume",
        quality: "quality",
        quick: "quick",
        quickTint: "quick tint",
        rM: "RM",
        raise: "raise",
        rcc: "rcc",
        reader: "reader",
        reboot: "reboot",
        receive: "receive",
        recirculate: "recirculate",
        recirculation: "recirculation",
        redlike: "Redlike",
        refill: "refill",
        registration: "registration",
        regular: "regular",
        removal: "removal",
        remove: "remove",
        report: "report",
        reset: "reset",
        resolution: "resolution",
        restart: "restart",
        rgb: "rgb",
        rights: "rights",
        rounding: "rounding",
        rules: "rules",
        sanTint: "SanTint",
        save: "save",
        scale: "scale",
        scan: "scan",
        scope: "scope",
        screen: "screen",
        screensaver: "screensaver",
        search: "search",
        secondaryCurrency: "secondary currency",
        select: "select",
        selectedFormula: "Selected formula",
        sell: "sell",
        sensor: "sensor",
        serialNumber: "serial number",
        server: "server",
        servers: "servers",
        service: "service",
        serviceAction: "service action",
        serviceActions: "service actions",
        serviceSoftware: "service software",
        serviceWindow: "service window",
        settings: "settings",
        shelf: "shelf",
        shortcuts: "shortcuts",
        shot: "shot",
        show: "show",
        shutDown: "shut down",
        shutdown: "shutdown",
        silent: "Silent",
        simple: "simple",
        simulation: "simulation",
        size: "size",
        skip: "skip",
        smartPurge: "smart purge",
        software: "software",
        softwareSupplier: "software supplier",
        sort: "sort",
        sound: "sound",
        spectro: "spectro",
        spectrophotometer: "spectrophotometer",
        speed: "speed",
        split: "split",
        start: "start",
        startup: "startup",
        statistics: "statistics",
        status: "status",
        stir: "stir",
        stirring: "stirring",
        street: "street",
        support: "support",
        surcharge: "surcharge",
        tab: "tab",
        tabs: "tabs",
        task: "task",
        template: "template",
        testing: "testing",
        time: "time",
        tintingManagementCenter: "tinting management center",
        to: "to",
        toDispense: "to dispense",
        tolerance: "tolerance",
        top: "top",
        total: "total",
        translation: "translation",
        turnOff: "turn off",
        turntable: "turntable",
        type: "type",
        uIDD: "UIDD",
        uSGallon: "U.S gallon",
        uSQuart: "U.S quart",
        unit: "unit",
        up: "up",
        update: "update",
        url: "url",
        user: "user",
        userGroups: "user groups",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VAT",
        validate: "validate",
        validation: "validation",
        version: "version",
        virtual: "virtual",
        volume: "volume",
        weekly: "weekly",
        window: "window",
        windows: "Windows",
        with: "with",
        without: "without",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y value",
        zipCode: "zip code",
        zoom: "zoom"
    },
    languages: {
        bg: "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸",
        cs: "ÄeÅ¡tina",
        da: "Danish",
        de: "Deutsch",
        el: "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬",
        en: "English",
        es: "EspaÃ±ol",
        fr: "FranÃ§ais",
        hr: "Hrvatski",
        hu: "Magyar",
        id: "Bahasa Indonesia",
        is: "Ãsland",
        it: "Italiano",
        lt: "Lithuanian",
        lv: "Latvian",
        ms: "Melayu",
        nl: "Nederland",
        no: "Norway",
        pl: "Polszczyzna",
        pt: "PortuguÃªs",
        ro: "Romana",
        ru: "Ð ÑÑÑÐºÐ¸Ð¹",
        sk: "SlovenÄina",
        sr: "Srpski",
        sv: "Sverige",
        zh: "Chinese"
    },
    license: {
        activateLicense: "AktivizÄt licenci",
        activateNewLicense: "AktivizÄt jaunu licenci",
        checkLicenseKey: "PÄrbaudÄ«t licences kodu",
        companyId: "UzÅÄmuma ID",
        contactPerson: "Kontaktpersona",
        copy: "KopÄt",
        country: "Valsts",
        emptyCity: "PilsÄta jÄnorÄda obligÄti",
        emptyCountry: "Valsts jÄnorÄda obligÄti",
        emptyName: "VÄrds jÄnorÄda obligÄti",
        enterIdentificationKeys: "IevadÄ«t identifikÄcijas kodu",
        expirationDate: "Beigu termiÅÅ¡ %{dateTime}",
        fillRegistration: "AizpildÄ«t reÄ£istrÄcijas datus",
        insertLicense: "Ievadiet Ä£enerÄto offline aktivizÄcijas kodu",
        invalidEmail: "E-mail nav derÄ«gs",
        invalidPhone: "Tel. numurs nav derÄ«gs",
        itemsMarkedasterisk: "Ar * apzÄ«mÄtie lauki jÄaizpilda obligÄti",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "IznomÄta licence",
        licenseActivated: "License already activated",
        licenseStatus: "Licences statuss",
        licenseWillExpire: "Licence beigsies pÄc %{dayCount} dienÄm",
        licenseWillExpireOneDay: "Your license expires in %{dayCount} day",
        machineInformation: "MaÅ¡Ä«nas informÄcija",
        noLicenseAvailable: "Licence nav pieejama",
        noProductsForKey: "NorÄdÄ«tajÄm identifikÄcijas atslÄgÄm nav pieejami produkti.",
        pointOfSale: "TirdzniecÄ«bas vieta",
        producer: "RaÅ¾otÄjs",
        reactivate: "Reactivate",
        reactivateLicense: "Reactivate license",
        region: "ReÄ£ions",
        registerLicense: "Åemiet aktivizÄÅ¡anas pieprasÄ«juma kopiju un dodieties uz ",
        registrationForm: "ReÄ£istrÄcijas forma",
        selectProduct: "IzvÄlÄties produktu",
        serialNumber: "SÄrijas numurs",
        skipNewLicense: "If you want to activate new license later you can click on Skip",
        unlimitedLicense: "NeierobeÅ¾ota licence",
        userId: "LietotÄja ID",
        uuid: "Licences UUID",
        versionDetails: "Versijas detaÄ¼as",
        versionScope: "Vesijas joma",
        versionType: "Versijas tips",
        zip: "Pasta indekss"
    },
    login: {
        authenticate: "Authenticate",
        logIn: "PierakstÄ«ties",
        loginAs: "PierakstÄ«ties kÄ cits lietotÄjs",
        messages: {
            incorrectUsername: "LietotÄja vÄrds vai parole ir nepareizi"
        },
        password: "Parole",
        username: "LietotÄja vÄrds "
    },
    machineActionHistory: {
        actionHistory: "DarbÄ«bu vÄsture"
    },
    machineErrors: {
        channel: "KanÄls",
        code: "KrÄsas tonis",
        machineErrors: "MaÅ¡Ä«nas kÄ¼Å«da",
        noMachineErrors: "There are currently no machine errors",
        resetErrors: "AtiestatÄ«t kÄ¼Å«du"
    },
    machineSettings: {
        action: "DarbÄ«ba",
        addAutotask: "Pievienot autotask",
        autoCanisterIn: "Auto kolbas iekÅ¡Ä",
        autoCanisterOut: "Auto kolbas ÄrÄ",
        automaticRefill: "AutomÄtiskÄ uzpildÄ«Å¡ana",
        autotaskSettings: "Autotask iestatÄ«jumi",
        backupConfiguration: "Rezerves kopija maÅ¡Ä«nas iestatÄ«jumiem",
        brushMaintenance: "Birstes apkope",
        capMaintenance: "VÄku apkope",
        checkCanisterBeforeDispense: "PÄrbaudiet maÅ¡Ä«nu pirms dozÄÅ¡anas",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Check the minimal tintable amount of colorants",
        checkOverfill: "Check can overfill",
        checkTotalCntAmounts: "Check total colorants amount for base paint",
        cleanAll: "Skalot visu",
        computerReboot: "Datora pÄrstartÄÅ¡ana",
        computerShutdown: "Datora izslÄgÅ¡ana",
        connectMachine: "Pievienot maÅ¡Ä«nu",
        days: "Dienas",
        daysOfMonth: "MÄneÅ¡a dienas",
        devices: "IekÄrtas",
        disabled: "DeaktivÄts",
        dispenseAndPurge: "DozÄt un skalot",
        dispenseOnly: "Tikai dozÄt",
        dispenserCleaning: "MaÅ¡Ä«nas tÄ«rÄ«Å¡ana",
        dispensingWithErrorsEnabled: "Allow dispensing despite the validation errors",
        editAutotask: "IestatÄ«t autotask",
        firstRun: "First run",
        hours: "Stundas",
        humidifier: "MitrinÄtÄjs",
        humidifierWaterLevelMaintenance: "MitrinÄtÄja Å«dens lÄ«menis",
        machineConfigurationNoCanisters: "The machine configuration contains no canisters.",
        machineName: "MaÅ¡Ä«nas nosaukums",
        machineSettings: "MaÅ¡Ä«nas iestatÄ«jumi",
        manualPuncher: "ManuÄlÄ caurumu Å¡tance",
        minDispensedAmount: "MinimÄlais dozÄÅ¡anas apjoms",
        minutes: "MinÅ«tes",
        nextRun: "NÄkoÅ¡ais gÄjiens",
        noAutotasksSet: "No autotasks set",
        noDataAvailable: "No data available",
        noMachine: "MaÅ¡Ä«na nav pievienota",
        onStart: "StartÄjot",
        plugger: "StrÄvas apgÄde",
        postpone: "PÄrcelt",
        puncher: "Caurumu Å¡tance",
        purgeAll: "Visu skalot",
        purgeOnly: "Purge only",
        recirculateAll: "CirkulÄt visiem",
        recirculateChannels: "CirkulÄt noteiktiem kanÄliem",
        recirculationSpeed: "CirkulÄcijas Ätrums",
        recirculationTime: "CirkulÄcijas laiks",
        refillAll: "UzpildÄ«t visus",
        refillCanisters: "UzpildÄ«t kolbas",
        runAt: "IeslÄgt laikÄ",
        runDefinedDaysAt: "IeslÄgt noteiktÄs dienÄs",
        runEvery: "IeslÄgt katru",
        runInDays: "DarbÄ«bas laiks dienÄs",
        serialNum: "SÄrijas numurs",
        settingsMachine: "MaÅ¡Ä«nas iestatÄ«jumi",
        smartPurgeAll: "InteliÄ£entÄ skaloÅ¡ana visiem",
        smartPurgeChannels: "InteliÄ£entÄ skaloÅ¡ana kanÄliem",
        smartPurgeRules: "InteliÄ£entÄs skaloÅ¡anas noteikumi",
        startType: "Starta tips",
        stirAll: "MaisÄ«t visus",
        stirCanisters: "MaisÄ«t kolbas",
        stirringSpeed: "MaisÄ«Å¡anas Ätrums",
        stirringTime: "MaisÄ«Å¡anas laiks",
        switchPlateMaintenance: "SlÄdÅ¾u plates apkope",
        theCurrentlySelectedMachine: "PaÅ¡laik izvÄlÄtÄ maÅ¡Ä«na",
        threshold: "RobeÅ¾vÄrtÄ«ba",
        turntable: "Kolbu galds",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Apjoms",
        weekdays: "DarbdienÄs"
    },
    mainTab: {
        acceptedFormula: "Accepted formula",
        addBuildingSite: "Add building site",
        addToFavorites: "Pievienot favorÄ«tiem",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Viens vai vairÄki pigmenti nav derÄ«gi",
        dispensedPackages: "DozÄtie iepakojumi",
        dispensingInProgress: "Notiek dozÄÅ¡ana",
        dispensingIsAborted: "DozÄÅ¡ana tiek pÄrtraukta",
        dispensingIsNotAvailable: "DozÄÅ¡ana nav iespÄjama",
        dispensingProgress: "%{done} no %{all}",
        editColorant: "MainÄ«t pigmentu",
        editNote: "MainÄ«t piezÄ«mi",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Piespiedu dozÄÅ¡ana",
        formulaInvalidColorants: "ReceptÅ«ra satur nederÄ«gus pigmentus: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Hidden fandecks",
        hiddenProducts: "Hidden products",
        historicalFormulas: "VÄsturiskÄs receptes",
        lowerDeltaNumber: "Lower delta number more accurate match",
        machineError: "MaÅ¡Ä«nas kÄ¼Å«da",
        machineIsBusy: "MaÅ¡Ä«na ir aizÅemta",
        machineNotConnected: "MaÅ¡Ä«na nav pievienota",
        manualColorantAddition: "ManuÄla pigmentu pievienoÅ¡ana",
        modifiedFormula: "Recepte ir modificÄta",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "New color after scaling",
        newRgbNotAccuratelyMeasured: "New RGB is not accurately measured, it is only indicative",
        noBaseAvailable: "BÄze nav pieejama",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Nav pigmentu",
        noCustomer: "Nav klienta",
        noCustomers: "Nav klientu",
        noDispenseNotesAvailable: "Nav dozÄÅ¡anas piezÄ«mju",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Nav izvÄlÄta receptÅ«ra",
        noInternalNotesAvailable: "No internal notes are available",
        noNotesAvailable: "Nav piezÄ«mju",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Nav izvÄlÄts iepakojums",
        noProductAvailable: "No product is available",
        noResultsFound: "No results found",
        openLocalFile: "Open from local database",
        openOnlineFile: "Open from the Internet",
        order: "PasÅ«tÄ«jums",
        orderingIsNotAvailable: "PasÅ«tÄ«jums nav pieejams",
        originalColor: "Original color",
        overAvailableLevel: "Virs pieejamÄ lÄ«meÅa",
        package: "Taros dydis",
        packageIsRequired: "Package is required",
        packaging: "Packaging",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Nav iespÄjams drukÄt",
        productFiles: "Produkta dati",
        productFilesViewer: "Product files viewer",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "RegulÄrÄ cena",
        resetFormulaData: "Jauna recepte",
        rgbOnlyIndicative: "RGB only indicative!",
        saveAsCustom: "SaglabÄt kÄ individuÄlo ",
        saveToStatsIsNotAvailable: "Nav iespÄjams saglabÄt vÄsturÄ",
        searchForCheaper: "Search for cheaper",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "SpeciÄls piedÄvÄjums ",
        specialPriceVip: "SpeciÄlÄ cena VIP",
        splitFormula: "ApvienotÄ receptÅ«ra",
        withVAT: "Ar PVN",
        withoutVAT: "Bez PVN"
    },
    marginSettings: {
        allBases: "Visas bÄzes",
        allProducts: "Visi produkti",
        editMargin: "MainÄ«t marÅ¾u",
        marginAndDiscountWarning: "You have to set price calculation option for using margins and discounts.",
        marginSettings: "MarÅ¾as iestatÄ«jumi",
        marginsFor: "MarÅ¾a priekÅ¡",
        markupColorants: "Pigmentu uzcenojums",
        sizeOfPackage: "Iepakojuma lielums",
        valueBase: "Value base",
        valueColorant: "Value colorant"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "MainÄ«t pigmentu mÄrvienÄ«bu",
        payAttention: "UzmanÄ«gi!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "PaleÅ¡u filtrs",
            formulasOverLimit: "VairÄk kÄ %{count} rezultÄtu. LÅ«dzam ievadÄ«t vairÄk rakstuzÄ«mes.",
            foundFormulas: "Atrastas %{count} receptÅ«ras",
            help: "PalÄ«dzÄ«ba:",
            helpText:
                "Ievadiet '%{filter}', lai meklÄtu pÄc receptÄm, kas sÄkas ar '%{formula}', pÄc produkta,  sÄkas ar '%{product}', un pÄc paletÄm '%{fandeck}'",
            productFilter: "Produktu filtrs",
            searchInFormulas: "MeklÄt pÄc receptÄm",
            typeMore: "LÅ«dzu ievadiet vairÄk rakstuzÄ«mes"
        },
        menu: {
            actionHistory: "DarbÄ«bu vÄsture",
            additionalFormulaTab: "Papildus receptÅ«ras tabula",
            advancedSettings: "AdvancÄtie iestatÄ«jumi",
            autotaskSettings: "AutomÄtiskie iestatÄ«jumi",
            availableDatabases: "PieejamÄs datu bÄzes",
            availablePrices: "PieejamÄs cenas",
            bugReport: "KÄ¼Å«du atskaite",
            canisterBarcodes: "Kolbu svÄ«trukodi",
            canisterDispensingLogic: "TonÄÅ¡anas loÄ£ika",
            canisterFilling: "Kolbu piepildÄ«jums",
            canisterSettings: "Kolbu iestatÄ«jumi",
            clientServerSettings: "Klientu servera iestatÄ«jumi",
            closing: "AizvÄrÅ¡ana",
            color: "Tonis",
            colorModification: "ToÅa modifikÄcija",
            colorPanel: "Color Palette Settings",
            colorRepresentation: "ToÅu pÄrÄdÄ«Å¡anÄs un dati",
            colorSearch: "KrÄsu meklÄÅ¡ana",
            colorant: "Pigments",
            colorantConsumption: "Colorant Consumption",
            colorantPricing: "Pigmentu cenas",
            colorantRefillHistory: "Pigmentu iepildÄ«Å¡anas vÄsture",
            competitiveSearch: "SalÄ«dzinoÅ¡Ä krÄsu meklÄÅ¡ana",
            connections: "Savienojumi",
            currency: "Valiutos nustatymai",
            customData: "Custom Data",
            database: "Datu bÄze",
            databaseCheck: "Datu bÄzes pÄrbaude",
            databaseConnection: "Savienojums ar datu bÄzi",
            defaultValues: "Default Values",
            devices: "IerÄ«ces",
            dispensingHistory: "TonÄÅ¡anas vÄsture",
            dispensingSettings: "TonÄÅ¡anas iestatÄ«jumi",
            driverSettings: "Draivera iestatÄ«jumi",
            environment: "Vide",
            environmentConfiguration: "Vides konfigurÄcija",
            environmentalSettings: "Vides iestatÄ«jumi",
            favorites: "FavorÄ«ti",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatting",
            formula: "Formula",
            formulaData: "Dati",
            formulaModification: "Formula modification",
            formulaPanels: "ReceptÅ«ru paneÄ¼i",
            formulaSettings: "ReceptÅ«ras iestatÄ«jumi",
            formulaUnit: "ReceptÅ«ru mÄrvienÄ«bas",
            generalSearch: "VispÄrÄjÄ meklÄÅ¡ana",
            globalSettingsSearch: "Global Settings Search",
            helpItems: "PalÄ«dzÄ«bas iestatÄ«jumi",
            importAndExport: "ImportÄt un eksportÄt",
            importAndExportData: "Ä®kelti savo duomenis",
            importCustomData: "IndividuÄlo datu imports",
            initialFormulaTab: "SÄkotnÄjÄs formulas cilne",
            interfaceSettings: "Izskata iestatÄ«jumi",
            keyboardShortcuts: "TaustiÅu Ä«sceÄ¼i",
            language: "Valodas iestatÄ«jumi",
            languageSettings: "Valodu iestatÄ«jumi",
            layout: "Izskats",
            license: "Licence",
            licenseData: "Licences dati",
            licenseIdentification: "Licences identifikÄcija",
            licenseStatus: "Licences statuss",
            licenseSupplier: "Licences piegÄdÄtÄjs",
            licenseVersion: "Licences versija",
            localData: "Local Data",
            machine: "MaÅ¡Ä«nas informÄcija",
            machineActions: "MaÅ¡Ä«nas darbÄ«bas",
            machineAndDevices: "MaÅ¡Ä«nas un ierÄ«ces",
            machineManagement: "MaÅ¡Ä«nas vadÄ«ba",
            machineSettings: "MaÅ¡Ä«nas iestatÄ«jumi",
            mainSettings: "Main Settings",
            maintenance: "MaÅ¡Ä«nas apkope",
            marginAndDiscount: "Margin and discount",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "NavigÄcijas elementi",
            newFormulaWindow: "ReceptÅ«ra",
            orderSearch: "PasÅ«tÄ«jumu meklÄÅ¡ana  ",
            orderSettings: "PasÅ«tÄ«jumu iestatÄ«jumi",
            packageSurcharge: "Package Surcharge",
            popUps: "IzlecoÅ¡ie logi",
            posInfo: "POS informÄcija",
            price: "Cena",
            priceManagement: "Cenu pÄrvaldÄ«Å¡ana",
            priceSettings: "Cenas iestatÄ«jumi",
            pricingOptions: "Pricing Options",
            printSettings: "Printera iestatÄ«jumi",
            productPricing: "Produkta cenas veidoÅ¡ana",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "ManuÄla dozÄÅ¡ana",
            rccConfig: "RCC konfigurÄcija",
            rccConnection: "RCC savienojums",
            rccSettings: "RCC iestatÄ«jumi",
            refillSettings: "Refill Settings",
            refillingLogic: "Refilling Logic",
            registration: "ReÄ£istrÄcija ",
            searchSettings: "MeklÄÅ¡anas iestatÄ«jumi",
            serverPlugins: "Servera spraudÅi",
            serviceActions: "Servisa darbÄ«bas",
            settings: "IestatÄ«jumi",
            simplifiers: "VienkÄrÅ¡otÄji",
            singleActions: "AtseviÅ¡Ä·as darbÄ«bas",
            smartPurgeRules: "InteliÄ£entÄs skaloÅ¡anas noteikumi",
            softwareOptions: "Programmas iespÄjas",
            spectroSettings: "Spektrometra iestatÄ«jumi",
            statistics: "Statistika",
            switchToFrontdesk: "Uz galveno paneli",
            switchToFullRedlike: "Uz %{name} ",
            switchToLight: "Uz %{name} ",
            switchToMachine: "Uz maÅ¡Ä«nu",
            tabs: "Tabulas un uzlecoÅ¡ie logi",
            testBarcodes: "SvÄ«trukodu tests",
            updateOptions: "AtjauninÄjumu iestatÄ«jumi",
            userManagemenet: "LietotÄju vadÄ«ba",
            visibleUnits: "RedzamÄs mÄrvienÄ«bas"
        },
        navBar: {
            barcode: "SvÄ«trukods",
            help: "PalÄ«dzÄ«bas  ",
            hideItems: "Hide products / fandecks"
        },
        notificationPanel: {
            noNotifications: "Nav jaunu paziÅojumu"
        },
        tabBar: {
            closeActive: "AizvÄrt aktÄ«vo karti",
            closeAll: "AizvÄrt visas kartes",
            closeAllExceptActive: "AizvÄrt visu izÅemot aktÄ«vÄs kartes",
            customFormula: "Custom Formula",
            dispensingHistory: "TonÄÅ¡anas vÄsture",
            favorites: "FavorÄ«ti",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "PieÅ¡Ä·irt",
        assignment: "PieÅ¡Ä·irÅ¡ana",
        createdDate: "IzveidoÅ¡anas datums",
        finishDispensing: "Beigt dozÄÅ¡anu",
        foundInOrders: "Atrast pasÅ«tÄ«jumos",
        inactiveDatabase: "ReceptÅ«ra no neaktÄ«vas vai nezinÄmas datu bÄzes %{0}",
        inactiveUnknownDatabase: "ReceptÅ«ra no neaktÄ«vas vai nezinÄmas datu bÄzes ",
        newOrderReceived: "Ir saÅemts jauns pasÅ«tÄ«jums!",
        noOrderSelected: "Nav izvÄlÄts neviens pasÅ«tÄ«jums",
        release: "ApstiprinÄt",
        status: {
            accepted: "AkceptÄts",
            canceled: "Atcelt",
            created: "Izveidot",
            done: "Gatavs",
            partlyDone: "DaÄ¼Äji izdarÄ«ts",
            preparing: "Tiek sagatavots",
            unknown: "NezinÄms"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adrese",
        contactName: "Kontakta nosaukums",
        contactPerson: "Kontaktpersona",
        identification: "IdentifikÄcija",
        machineInformation: "MaÅ¡Ä«nas informÄcija",
        pos: "TirdzniecÄ«bas vieta (POS)",
        secondAddress: "AlternatÄ«vÄ adrese",
        shopIdentification: "TirdzniecÄ«bas vietas identifikÄcija",
        shopName: "Veikala nosaukums",
        url: "URL",
        zipCode: "Pasta indekss"
    },
    priceTypeList: {
        priceBasePurchase: "Pamata iepirkuma cena",
        priceBaseSell: "Pamata pÄrdoÅ¡anas cena",
        priceBaseSellFull: "Sell full price for base",
        priceCntPurchase: "Iepirkuma cena pigmentiem  ",
        priceCntPurchaseByColorantName: "Izmaksas pigmentam %{0} ",
        priceCntPurchaseByName: "Izmaksas pigmentam pÄc nosaukuma",
        priceCntSell: "PÄrdoÅ¡anas cena pigmentiem  ",
        priceCntSellByColorantName: "PÄrdoÅ¡anas cena pigmentam %{0} ",
        priceCntSellByName: "PÄrdoÅ¡anas cena pigmentiem pÄc nosaukuma",
        priceCntSellFull: "Sell full price for colorants",
        priceCntSellFullByColorantName: "Sell full price for %{0} colorant",
        priceCntSellFullByName: "Sell full price for colorants by name",
        priceGroupBarcode: "Price group barcode",
        priceMarginAll: "MarÅ¾a visiem iepakojumiem",
        priceMarginPerPkg: "MarÅ¾a vienam iepakojumam",
        priceSellPriceAll: "PÄrdoÅ¡anas cena visiem iepakojumiem  ",
        priceSellPricePerKg: "PÄrdoÅ¡anas cena kilogramam",
        priceSellPricePerL: "PÄrdoÅ¡anas cena litram",
        priceSellPricePerPkg: "PÄrdoÅ¡anas cena vienam iepakojumam",
        priceSurchargeAll: "MinimÄlÄ maksa visiem iepakojumiem",
        priceSurchargePerPkg: "MinimÄlÄ maksa vienam iepakojumam",
        priceTintPurchaseAll: "TonÄÅ¡anas izmaksas visiem iepakojumiem",
        priceTintPurchasePerPkg: "TonÄÅ¡anas izmaksas vienam iepakojumam",
        priceTintSellFullAll: "Tint sell full price for all packages",
        priceTintSellFullAllPerPackage: "Tint sell full price per package",
        priceTotalPurchaseAll: "KopÄjÄs izmaksas visiem iepakojumiem]",
        priceTotalPurchasePerKg: "KopÄjÄs izmaksas vienam kilogramam",
        priceTotalPurchasePerL: "KopÄjÄs izmaksas vienam litram",
        priceTotalPurchasePerPkg: "KopÄjÄs izmaksas vienam iepakojumam",
        priceTotalSellFullAll: "Total sell full price for all packages",
        priceTotalSellFullPerKg: "Total sell full price per kilogram",
        priceTotalSellFullPerLiter: "Total sell full price per liter",
        priceTotalSellFullPerPackage: "Total sell full price per package"
    },
    pricing: {
        allBases: "Visas bÄzes",
        allPackages: "Visi iepakojumi",
        backup: "Backup",
        basesOfProduct: "Bases of %{productName}",
        colorantPricing: "Uzcenojums pigmentam",
        export: "Eksports",
        import: "Imports",
        packagePricing: "Iepakojuma cenas veidoÅ¡ana",
        packageSurcharge: "MinimÄlÄ cena iepakojumam",
        packages: "Iepakojumi",
        packagesOfProduct: "Packages of %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Cenu grupa - cena par litru",
        priceGroups: "Cenu grupas",
        pricePerLiter: "Cena par litru",
        productPricing: "Produkta cenas veidoÅ¡ana",
        purchasePrice: "Izmaksas",
        purchasePricePerLiter: "Izmaksas litram",
        sellPrice: "Sell price",
        surcharge: "MinimÄlÄ maksa"
    },
    print: {
        adminRightsRequired: "Admin rights are required to edit or create a new template.",
        allowAutomaticPrint: "AtÄ¼aut automÄtisku drukÄÅ¡anu",
        allowPrintAfterDispensing: "AtÄ¼aut drukÄÅ¡anu pÄc tonÄÅ¡anas",
        allowPrintBeforeDispensing: "AtÄ¼aut drukÄÅ¡anu pirms tonÄÅ¡anas",
        automaticPrint: "AutomÄtiskÄ druka",
        choosePrinter: "IzvÄlÄties printeri",
        chooseSettings: "IzvÄlÄties iestatÄ«jumus",
        chooseTemplate: "IzvÄlÄties sagataves",
        copies: "Copies",
        createTemplate: "Create template",
        createTemplateHint: "Create a new template from scratch. Save it to the templates folder and restart RCC.",
        defaultPrinter: "Pamata printeris",
        defaultSettings: "Default settings",
        defaultTemplate: "Pamata sagatave",
        editTemplate: "Edit template",
        editTemplateHint: "Edit %{name}. Changes will be visible after RCC restart.",
        noEditTemplate: "No template to edit",
        noPrinterSelected: "Nav izvÄlÄts printeris",
        noPrintersAvailable: "Printeri nav pieejami",
        noTemplateSelected: "Nav izvÄlÄts Å¡ablons",
        noTemplatesAvailable: "Å ablonai nepasiekiami",
        numberOfCopies: "Kopiju skaits",
        openTemplateEditor: "AtvÄrt sagatavju pÄrvaldnieku",
        printAfterDispensing: "Druka pÄc tonÄÅ¡anas",
        printAsImage: "DrukÄt kÄ attÄlu",
        printBeforeDispensing: "Druka pirms tonÄÅ¡anas",
        printOnRequest: "Druka pÄc pieprasÄ«juma",
        printOptions: "PrintÄÅ¡anas iespÄjas",
        printPagesAfterDispensing: "Kopiju skaits pÄc tonÄÅ¡anas",
        printPagesBeforeDispensing: "Kopiju skaits pirms tonÄÅ¡anas",
        printPreview: "PrintÄÅ¡anas priekÅ¡skatÄ«jums",
        printSettings: "Drukas iestatÄ«jumi",
        printTaskLinkVariable: "Link to a variable",
        printVariable: "Print variable",
        printerName: "Printera nosaukums",
        printerOptions: "Printera iespÄjas",
        printerSettings: "Printera iestatÄ«jumi",
        quickTintTemplate: "Sagataves manuÄlai ievadÄ«Å¡anai",
        setDefaultPrinter: "IestatÄ«t pamata printeris",
        setDefaultTemplate: "IestatÄ«t pamata sagataves",
        setQuickTintTemplate: "IestatÄ«t sagataves manuÄlai ievadÄ«Å¡anai",
        showPreviewDialogBeforePrint: "Show preview dialog before print",
        template: "Sagataves",
        templateName: "Sagataves nosaukums",
        templateSettings: "Å ablona iestatÄ«jumi"
    },
    printTemplate: {
        baseCode: "BÄzes kods",
        baseName: "BÄzes nosaukums",
        bfs: "BFS klase",
        colorantType: "Colorant type",
        customerCity: "Klienta pilsÄta",
        customerEmail: "Klienta e-mail",
        customerName: "Klienta nosaukums",
        customerPhone: "Klienta telefons",
        customerStreet: "Klienta iela",
        customerZipCode: "Klienta pasta indekss",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS klase",
        orderQrCode: "QR kods",
        packageOrderCount: "Package order count",
        posAddress: "Veikala adrese",
        posAddressSecond: "Veikala adrese 2",
        posCity: "Veikala pilsÄta",
        posContact: "Veikala kontakts",
        posEmail: "Veikala e-mail",
        posPhone: "Veikala telefons",
        posUrl: "Veikala URL",
        posZipCode: "Veikala pasta indekss",
        priceBasePurchaseWithTax: "BÄzes izmaksas ar PVN",
        priceBaseSellWithTax: "BÄzes pÄrdoÅ¡anas cena ar PVN",
        priceCntPurchaseWithTax: "Pigmentu izmaksas ar PVN",
        priceCntTotalSellWithTax: "Pigmentu pÄrdoÅ¡anas cena PVN",
        priceMarginAllWithTax: "MarÅ¾a visiem iepakojumiem ar PVN",
        priceMarginPerPkgWithTax: "MarÅ¾a vienam iepakojumam ar PVN",
        priceSellPriceAllWithTax: "PÄrdoÅ¡anas cena visiem iepakojumiem ar PNV",
        priceSellPricePerKgWithTax: "PÄrdoÅ¡anas cena par kg ar PVN",
        priceSellPricePerLWithTax: "PÄrdoÅ¡anas cena par litru ar PVN  ",
        priceSellPricePerPkgWithTax: "PÄrdoÅ¡anas cena vienam iepakojumam ar PVN",
        priceSurchargeAllWithTax: "MinimÄlÄ cena visiem iepakojumiem ar PVN",
        priceSurchargePerPkgWithTax: "MinimÄlÄ cena vienam iepakojumam ar PVN",
        priceTintPurchaseAllWithTax: "TonÄÅ¡anas izmaksas visiem iepakojumiem ar PVN",
        priceTintPurchasePerPkgWithTax: "TonÄÅ¡anas izmaksas vienam iepakojumam ar PVN",
        priceTotalPurchaseAllWithTax: "KopÄjÄs izmaksas visiem iepakojumiem ar PVN",
        priceTotalPurchasePerKgWithTax: "KopÄjÄs izmaksas uz kilogramu ar PVN",
        priceTotalPurchasePerLWithTax: "KopÄjÄs izmaksas uz litru ar PVN",
        priceTotalPurchasePerPkgWithTax: "KopÄjÄs izmaksas vienam iepakojumam ar PVN",
        productAltName: "Produkts",
        recipeInline: "ReceptÅ«ra"
    },
    products: {
        bases: "BÄzes",
        numberOfProducts: "Produktu skaits",
        packagesFor: "Iepakojumu/ bÄzu cena",
        sizeOfPackage: "Iepakojums"
    },
    purgeModal: {
        purgeAll: "Skalot visas sprauslas",
        purgeAllChannels: "IzpÅ«st visus kanÄlus",
        purgeVolume: "SkaloÅ¡anas apjoms",
        startPurge: "SÄkt sprauslu skaloÅ¡anu"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "PaÅ¡laik tiek tonÄts",
        dispensingIsNotAvailable: "TonÄÅ¡ana nav iespÄjama",
        machineNotConnected: "MaÅ¡Ä«na nav pieslÄgta",
        noColorantsSelected: "Nav izvÄlÄti pigmenti",
        noPrinterAvailable: "Nav iespÄjams drukÄt, jo nav pieejami printeri",
        noTemplateAvailable: "Nav iespÄjams drukÄt, jo nav pieejamas sagataves",
        overMaxCanisterSize: "Viens vai vairÄki pigmenti nav derÄ«gi"
    },
    quickTintSettings: {
        alphabetically: "AlfabÄtiski",
        byCanister: "PÄc kolbÄm",
        closeAfterDispensing: "AizvÄrt pÄc tonÄÅ¡anas",
        closeBeforeDispensing: "AizvÄrt pirms tonÄÅ¡anas",
        quickTintSettings: "ManuÄlÄ dozÄÅ¡ana",
        sorting: "KÄrtÄ«ba",
        windowClosingRules: "Logu aizvÄrÅ¡anas nosacÄ«jumi"
    },
    rccButtons: {
        abort: "PÄrtraukt",
        all: "Visi  ",
        cancel: "Atcelt",
        continue: "TurpinÄt",
        help: "PalÄ«dzÄ«ba",
        ignore: "IgnorÄt",
        no: "NÄ",
        noToAll: "Ne visi",
        ok: "OK",
        postpone: "PÄrcelt",
        resume: "TurpinÄt",
        retry: "MÄÄ£inÄt vÄlreiz",
        skip: "Atmest",
        yes: "JÄ",
        yesToAll: "JÄ visiem"
    },
    rccDialog: {
        98: "LÅ«dzam pÄrbaudÄ«t bÄzes %{0}  svÄ«trukodu",
        99: "Ievadiet lÅ«dzu bÄzi %{0} un apstipriniet (ok)",
        100: "TonÄÅ¡anas sistÄmÄ uzrÄda kÄ¼Å«du, vai atcelt kÄ¼Å«du?",
        101: "TonÄÅ¡anas sistÄma uzrÄda kÄ¼Å«du un nevar turpinÄt darbu",
        102: "PÄrstartÄÅ¡ana kÄ¼Å«daina, nav iespÄjams turpinÄt.",
        103: "ReceptÅ«ra satur nederÄ«gu pigmentu: %{0}",
        104: "ReceptÅ«ra satur nederÄ«gus pigmentus: %{0}",
        105: "Pigments: %{0} atrodas zem brÄ«dinÄjuma lÄ«meÅa",
        106: "Pigmenti: %{0} atrodas zem brÄ«dinÄjuma lÄ«meÅa",
        107: "Pigments: %{0} atrodas zem kritiskÄ lÄ«meÅa",
        108: "Pigmenti: %{0} atrodas zem kritiskÄ lÄ«meÅa",
        109: "Novietot iepakojumu",
        110: "Novietojiet bÄzes iepakojumu: %{0} receptÅ«rai: %{1}, pigments",
        111: "NoÅemt iepakojumu",
        112: "Vai jÄÅ¡tancÄ caurums?",
        113: "KÄ¼Å«da tiek atcelta, lÅ«dzam uzgaidÄ«t",
        114: "Plaukts kustÄ«bÄ, lÅ«dzam uzgaidÄ«t",
        115: "Tiek Å¡tancÄts caurums, lÅ«dzam uzgaidÄ«t",
        116: "Tiek tonÄts %{0}, lÅ«dzam uzgaidÄ«t | iepakojums: %{1} no %{2} | produkts:%{3} | bÄze: %{4} | tilpums: %{5}",
        117: "Tiek tonÄts %{0}, lÅ«dzam uzgaidÄ«t | iepakojums: %{1} no %{2} | produkts:%{3} | bÄze: %{4} | tilpums: %{5}",
        118: "Tiek tonÄts, lÅ«dzam uzgaidÄ«t | iepakojums: %{0} no %{1} ",
        119: "Tiek tonÄts, lÅ«dzam uzgaidÄ«t | iepakojums: %{0} no %{1} ",
        120: "PÄrtraukta tonÄÅ¡ana, lÅ«dzam uzgaidÄ«t",
        121: "PÄrbaudiet iepakojuma svÄ«trukodu",
        122: "PÄrbaudiet bÄzes kodu: produkts:%{0} | bÄze: %{1} | tilpums: %{2}",
        123: "TonÄÅ¡ana tika pÄrtraukta. Vai vÄlaties tonÄÅ¡anu turpinÄt?",
        124: "TonÄÅ¡anas maÅ¡Ä«nas kÄ¼Å«da %{0}: %{1}. Vai vÄlaties tonÄÅ¡anu turpinÄt?",
        125: "PÄrliecinieties, ka iepriekÅ¡ izmantotais iepakojums ir vietÄ.",
        126: "PÄrliecinieties, ka izmantojat jaunu iepakojumu, jo tonÄÅ¡ana tiks sÄkta no jauna",
        127: "Pigments: %{0} ir zem minimÄlÄ tonÄÅ¡anas daudzuma. Vai neskatoties uz to vÄlaties turpinÄt?",
        128: "Pigmenti: %{0} ir zem minimÄlÄ tonÄÅ¡anas daudzuma. Vai neskatoties uz to vÄlaties turpinÄt?",
        129: "IzvÄlÄtÄ receptÅ«ra pÄrsniedz tilpumu ierobeÅ¾ojumus. KopÄjais pigmentu daudzums: %{0} %{1}, maksimÄli pieÄ¼aujamÄ norma ir %{2} %{3}. Vai neskatoties uz to vÄlaties turpinÄt?",
        130: "TonÄÅ¡anas sistÄmÄ uzrÄda kÄ¼Å«du, vai atcelt kÄ¼Å«du?",
        131: "TonÄÅ¡anas sistÄma uzrÄda kÄ¼Å«du un nevar turpinÄt darbu",
        132: "PÄrstartÄÅ¡ana kÄ¼Å«daina, nav iespÄjams turpinÄt.",
        133: "SkaloÅ¡anas daudzums par mazu, nav iespÄjams turpinÄt",
        134: "SkaloÅ¡anas receptÅ«ra satur elementus, kas nevar tikt skaloti. Vai vÄlaties turpinÄt?",
        135: "Novietojiet trauku sprauslu skaloÅ¡anai",
        136: "Trauku pÄc skaloÅ¡anas noÅemt",
        137: "KÄ¼Å«da tiek atcelta, lÅ«dzam uzgaidÄ«t",
        138: "Plaukts kustÄ«bÄ, lÅ«dzam uzgaidÄ«t",
        139: "SkaloÅ¡ana, lÅ«dzam uzgaidÄ«t",
        140: "SkaloÅ¡ana, lÅ«dzam uzgaidÄ«t",
        141: "SkaloÅ¡ana tiek pÄrtraukta, lÅ«dzam uzgaidÄ«t",
        142: "TrÅ«kst trauks skaloÅ¡anai, lÅ«dzam pÄrbaudÄ«t vai trauks ir novietots pareizi",
        143: "SkaloÅ¡anas receptÅ«ra satur elementus, kas nevar tikt skaloti. Vai vÄlaties turpinÄt?",
        144: "Novietot trauku skaloÅ¡anai",
        145: "Tiek sagatavots, lÅ«dzam uzgaidÄ«t",
        146: "Tiek pabeigts, lÅ«dzam uzgaidÄ«t",
        150: "SkaloÅ¡ana, lÅ«dzam uzgaidÄ«t",
        151: "SkaloÅ¡ana, lÅ«dzam uzgaidÄ«t",
        152: "TÄ«rs, lÅ«dzam uzgaidÄ«t",
        160: "RecirkulÄcija, lÅ«dzam uzgaidÄ«t",
        161: "RecirkulÄcija, lÅ«dzam uzgaidÄ«t",
        162: "RecirkulÄcija pÄrtraukta, lÅ«dzam uzgaidÄ«t",
        170: "MaisÄ«Å¡ana, lÅ«dzam uzgaidÄ«t",
        171: "MaisÄ«Å¡ana, lÅ«dzam uzgaidÄ«t",
        172: "MaisÄ«Å¡ana pÄrtraukta, lÅ«dzam uzgaidÄ«t",
        180: "Savienojums ar tonÄjamo maÅ¡Ä«nu tiek palaists, lÅ«dzam uzgaidÄ«t",
        181: "Savienojums ar tonÄjamo maÅ¡Ä«nu nav iespÄjams %{0}: %{1}",
        182: "Savienojumu ar tonÄjamo maÅ¡Ä«nu nav iespÄjams izveidot. TÄlÄku informÄciju atradÄ«siet protokola datos.",
        183: "TonÄjamÄ maÅ¡Ä«nÄ trÅ«kst pigments: %{0}, kas ir definÄts jÅ«su datu bÄzÄ",
        184: "TonÄjamÄ maÅ¡Ä«nÄ trÅ«kst pigmentu: %{0}, kas ir definÄti jÅ«su datu bÄzÄ",
        185: "Savienojums ar tonÄjamo maÅ¡Ä«nu tiek pÄrtraukts, lÅ«dzam uzgaidÄ«t.",
        190: "Lai turpinÄtu, lÅ«dzam aizvÄrt servisa logu",
        200: "AtcelÅ¡ana, lÅ«dzam uzgaidÄ«t",
        201: "Piespiedu pÄrstartÄÅ¡ana, lÅ«dzam uzgaidÄ«t",
        202: "StartÄjas, lÅ«dzam uzgaidÄ«t",
        203: "PÄrstartÄÅ¡ana kÄ¼Å«daina, lÅ«dzam uzgaidÄ«t",
        205: "AutomÄtiskÄ aizvÄrÅ¡ana tiek atvÄrta, lÅ«dzam uzgaidÄ«t",
        206: "AutomÄtiskÄ aizvÄrÅ¡ana tiek aizvÄrta, lÅ«dzam uzgaidÄ«t",
        207: "AutomÄtiskÄ aizvÄrÅ¡ana turpinÄs, lÅ«dzam uzgaidÄ«t",
        210: "Cauruma Å¡tancÄÅ¡ana, lÅ«dzam uzgaidÄ«t",
        211: "PievienoÅ¡anÄs, lÅ«dzam uzgaidÄ«t",
        215: "Plaukts paceÄ¼as, lÅ«dzam uzgaidÄ«t",
        216: "Plaukts nolaiÅ¾as, lÅ«dzam uzgaidÄ«t",
        217: "Plaukts kustÄ«bÄ, lÅ«dzam uzgaidÄ«t",
        220: "Pigmentu galds pagrieÅ¾as uzpildÄ«Å¡anas pozÄ«cijÄ: %{0}, lÅ«dzam uzgaidÄ«t",
        221: "Pigmentu galds pagrieÅ¾as sÄkuma pozÄ«cijÄ, lÅ«dzam uzgaidÄ«t",
        222: "Pigmentu galds grieÅ¾as, lÅ«dzam uzgaidÄ«t",
        230: "MaÅ¡Ä«na aizÅemta, lÅ«dzam uzgaidÄ«t",
        240: "UzpildÄ«t kolbu %{0}",
        241: "LÅ«dzam uzpildÄ«t kolbu %{0}",
        242: "Kolbas: %{0} (%{1}) pagrieÅ¡ana uzpildÄ«Å¡anas pozÄ«cijÄ",
        243: "LÅ«dzam uzpildÄ«t kolbu %{0} lietojot svÄ«trukodu",
        244: "LÅ«dzam uzpildÄ«t kolbu %{0} lietojot svÄ«trukodu",
        250: "IzÅemiet mazgÄÅ¡anas birstes rezervuÄru, iztÄ«riet und uzpildiet vadoties pÄc norÄdÄ«jumiem",
        251: "Novietot mazgÄÅ¡anas birstes rezervuÄru atpakaÄ¼",
        254: "VÄks tiek atvÄrts",
        255: "NotÄ«riet vÄku saskaÅÄ ar norÄdÄ«jumiem",
        256: "LÅ«dzam pÄrbaudÄ«t, vai tÄ«rÄ«Å¡ana ir beigusies un vÄks ir atpakaÄ¼ savÄ vietÄ.",
        257: "VÄks tiek aizvÄrts",
        260: "NoÅemt un notÄ«rÄ«t noslÄgplati",
        261: "Novietot noslÄgplati atpakaÄ¼ vietÄ",
        265: "NotÄ«riet maÅ¡Ä«nu no pigmentu notecÄjumiem un citiem netÄ«rumiem.",
        266: "Apstipriniet, kad izdarÄ«ts",
        270: "Uzpildiet mitrinÄtÄja rezervuÄru un apstipriniet, kad izdarÄ«ts",
        271: "Uzpildiet mitrinÄtÄja rezervuÄru un apstipriniet, kad izdarÄ«ts",
        272: "LÄ«menis vÄl aizvien par zemu, lÅ«dzu pÄrbaudiet vÄlreiz",
        273: "LÄ«menis vÄl aizvien par zemu, lÅ«dzu pÄrbaudiet vÄlreiz",
        274: "PÄrbaudiet mitrinÄtÄja rezervuÄra lÄ«meni",
        275: "LÅ«dzam uzgaidÄ«t",
        280: "Dators tiek pÄrstartÄts",
        281: "Dators tiek izslÄgts",
        300: "BÄzes iepakojums nav vietÄ, lÅ«dzam pÄrbaudÄ«t.",
        301: "Tiek sagatavots, lÅ«dzam uzgaidÄ«t",
        302: "Tiek pabeigts, lÅ«dzam uzgaidÄ«t",
        303: "ReceptÅ«ra nevar tikt tonÄta, jo satur pigmentu: %{0}, kura daudzums receptÅ«rÄ ir virs maksimÄli definÄtÄs kolbas ietilpÄ«bas.",
        304: "ReceptÅ«ra nevar tikt tonÄta, jo satur pigmentus: %{0}, kuru daudzums receptÅ«rÄ ir virs maksimÄli definÄtÄs kolbas ietilpÄ«bas.",
        305: "Pigmentu: %{0} nav iespÄjams dozÄt vienÄ reizÄ, vai vÄlaties receptÅ«ru sadalÄ«t?",
        306: "Pigmentus: %{0} nav iespÄjams dozÄt vienÄ reizÄ, vai vÄlaties receptÅ«ru sadalÄ«t?",
        307: "Pigmentu %{0} nav iespÄjams dozÄt, vai vÄlaties turpinÄt un pievienot pigmentu manuÄli?",
        308: "Pigmentus %{0} nav iespÄjams dozÄt, vai vÄlaties turpinÄt un pievienot pigmentus manuÄli?",
        309: "IzvÄlÄtÄ receptÅ«ra ir tukÅ¡a, bÄzi var izmantot tÄ«rÄ veidÄ.",
        310: "Pigmenti nevar tikt dozÄti, sagatavojiet bÄzes manuÄlai pievienoÅ¡anai.",
        311: "NoÅemiet bÄzi, un sagatavojiet manuÄlai pigmenta pievienoÅ¡anai.",
        312: "Pievienojiet manuÄli %{0} %{1} pigmentu %{2}, apstipriniet, kad darÄ«ts",
        313: "ReceptÅ«ru dozÄt manuÄli",
        314: "IzvÄlÄtÄ receptÅ«ra pÄrsniedz maksimÄli pieÄ¼aujamo daudzumu pigmentiem %{0} %{1}, maksimÄli pieÄ¼aujamais daudzums ir %{2} %{3}. Vai vÄlaties turpinÄt?",
        315: "Scan or type UFI code of base can",
        316: "Scan or type UFI code of base can|Product: %{0}|Base: %{1}|Can size: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "AutomÄtiskÄ skaloÅ¡anas programma tiek startÄta",
        401: "AutomÄtiskÄ skaloÅ¡anas programma tiek startÄta",
        405: "Birstes rezervuÄram nepiecieÅ¡ama apkope",
        406: "Birstes rezervuÄram nepiecieÅ¡ama apkope",
        410: "AutomÄtiskÄ vÄka apkope tiek startÄta",
        411: "AutomÄtiskÄ vÄka apkope tiek startÄta",
        415: "SlÄdÅ¾u plati nepiecieÅ¡ams notÄ«rÄ«t",
        416: "SlÄdÅ¾u plati nepiecieÅ¡ams notÄ«rÄ«t",
        420: "MaÅ¡Ä«nai nepiecieÅ¡ama tÄ«rÄ«Å¡ana",
        421: "MaÅ¡Ä«nai nepiecieÅ¡ama tÄ«rÄ«Å¡ana",
        425: "Kolbu uzpildÄ«Å¡ana tiek startÄta.",
        426: "Kolbu uzpildÄ«Å¡ana tiek startÄta.",
        430: "Ir ieplÄnota datora pÄrstartÄÅ¡ana ",
        431: "Ir ieplÄnota datora pÄrstartÄÅ¡ana ",
        435: "Ir ieplÄnota datora izslÄgÅ¡ana",
        436: "Ir ieplÄnota datora izslÄgÅ¡ana",
        440: "Ir ieplÄnota maÅ¡Ä«nas tÄ«rÄ«Å¡ana",
        441: "Ir ieplÄnota maÅ¡Ä«nas tÄ«rÄ«Å¡ana",
        445: "Ir ieplÄnota maÅ¡Ä«nas recirkulÄcija",
        446: "Ir ieplÄnota maÅ¡Ä«nas recirkulÄcija",
        450: "Ir ieplÄnota maisÄ«Å¡ana kolbÄs",
        451: "Ir ieplÄnota maisÄ«Å¡ana kolbÄs",
        990: "MaÅ¡Ä«nas kÄ¼Å«da %{0}: %{1}. Vai vÄlaties atkÄrtoti iesniegt?",
        991: "Interneta kÄ¼Å«da: %{0}",
        200000001: "Novietojiet iepakojumu",
        200000002: "NoÅemiet iepakojumu",
        200000003: "%{0}' zem minimÄlÄ dozÄÅ¡anas daudzuma, vai turpinÄt uz jÅ«su atbildÄ«bu?",
        200000004: "%{0} uzpildÄ«t"
    },
    rccDriverSettings: {
        databasePath: "Datu bÄzes marÅ¡ruts",
        dispenser: "MaÅ¡Ä«na",
        dispenserConfigurationFile: "DozÄtÄja konfigurÄcijas fails",
        driverPath: "Draivera marÅ¡ruts",
        extensionPath: "PaplaÅ¡inÄjuma marÅ¡ruts",
        folder: "Mape",
        formulaPath: "ReceptÅ«ras marÅ¡ruts",
        host: "Host",
        iddPath: "IDD - konfigurÄcijas marÅ¡ruts",
        italtintoPath: "KonfigurÄcijas marÅ¡ruts Italtinto",
        lldPath: "LLD labojums",
        machineType: "MaÅ¡Ä«nas tips",
        noMachineAvailable: "MaÅ¡Ä«na nav pieejama",
        protocolVersion: "Protokola versija",
        rccDriverSettings: "Draivera iestatÄ«jumi",
        resultPath: "RezultÄtu marÅ¡ruts",
        save: "SaglabÄt",
        saveSettingsWarning: "UzmanÄ«bu! IzmaiÅas Å¡ajÄ nodaÄ¼Ä var novest pie iekÄrtas disfunkcijas",
        serviceSwPath: "Servisa programmatÅ«ras marÅ¡ruts",
        simulationPath: "SimulÄcijas marÅ¡ruts"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "AtÄ¼aut manuÄlu pigmentu pievienoÅ¡anu",
        ask: "JautÄt",
        canHandlingOptions: "Iepakojuma novietoÅ¡anas iespÄjas",
        checkCanBeforeDispense: "Parbaudiet iepakojumu pirms dozÄÅ¡anas",
        checkOverfill: "PÄrbaudiet pÄrplÅ«des iespÄjamÄ«bu",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Colorant package validation only",
        disable: "AtslÄgt",
        dispenseInvalidColorants: "DozÄt nederÄ«gus pigmentus",
        dispensingOptions: "DozÄÅ¡anas iespÄjas",
        enable: "PieslÄgt",
        enableUserIdentification: "User identification",
        fullValidation: "Full validation",
        machineAccuracyWarning: "MaÅ¡Ä«nas precizitÄtes brÄ«dinÄjums",
        machineOptions: "MaÅ¡Ä«nas iespÄjas",
        machineUnit: "MaÅ¡Ä«nas mÄrvienÄ«bas",
        minimalDispenseAmount: "MinimÄlÄ dozÄÅ¡anas iespÄja",
        placeCanSensor: "Novietot iepakojumu sensoru",
        placeCanSensorDelay: "Novietot iepakojuma sensora aizkavÄÅ¡anos",
        rccMachineSettings: "MaÅ¡Ä«nas iestatÄ«jumi",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "NoÅemt iepakojuma sensoru",
        removeCanSensorDelay: "NoÅemt iepakojuma sensora aizkavÄÅ¡anos",
        save: "SaglabÄt iestatÄ«jumus",
        sec: "sek.",
        skipPlaceCanDialog: "Izlaist iepakojuma novietoÅ¡anas dialogu",
        skipRemoveCanDialog: "Izlaist iepakojuma noÅemÅ¡anas dialogu",
        splitFormula: "SadalÄ«t receptÅ«ru",
        tmcEnabled: "PieslÄgt TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Ievadiet iepakojuma svÄ«trukodu",
        validateBarcodeRefill: "Kolbas svÄ«trukoda apstiprinÄjums pirms uzpildÄ«Å¡anas",
        validateColorantsDuringInit: "Pigmentu apstiprinÄÅ¡ana inicializÄcijas laikÄ"
    },
    rccPanel: {
        actionsRunningOnDispenser: "MaÅ¡Ä«nÄ notiek daÅ¾as darbÄ«bas",
        addLevel: "Pievienot daudzumu",
        addManually: "Add manually",
        barcodeNotSet: "Canister %{colorantName} (%{canisterName}) has no barcode assigned.",
        cancel: "Atcelt",
        dispenseFormula: "DozÄt receptÅ«ru",
        dispenserIdle: "MaÅ¡Ä«na ir neaktÄ«va",
        dispenserIsBusy: "MaÅ¡Ä«na ir aizÅemta",
        dispenserIsIdle: "MaÅ¡Ä«na ir neaktÄ«va",
        dispenserIsReady: "MaÅ¡Ä«na gatava darbam",
        dispensingFormula: "Dozavimas bus",
        errorCode: "KÄ¼Å«das kods",
        explanation: "Paskaidrojums",
        fillToMax: "UzpildÄ«t lÄ«dz pilnam",
        finished: "Finished",
        inProgress: "In progress",
        machineIsReady: "MaÅ¡Ä«na gatava darbam",
        moveToFill: "PÄrvietot uz uzpildÄ«Å¡anu",
        noMachineDialog: "MaÅ¡Ä«na nav pievienota",
        of: "no",
        packageSize: "Tilpums",
        placeBaseCan: "Novietot bÄzes iepakojumu",
        pleaseCheckYourMachineConnection: "LÅ«dzam pÄrbaudÄ«t savienojumu ar maÅ¡Ä«nu",
        pleaseRefill: "LÅ«dzam uzpildÄ«t",
        solution: "MaisÄ«jums",
        subErrors: "ApakÅ¡kÄ¼Å«da",
        timeToEnd: "Laiks lÄ«dz beigÄm",
        tintingFormula: "ReceptÅ«ras dozÄÅ¡ana",
        tintingPleaseWait: "Notiek dozÄÅ¡ana, lÅ«dzam uzgaidÄ«t",
        validateBaseCan: "ApstiprinÄt bÄzes iepakojumu",
        waiting: "Waiting"
    },
    rccSettigns: {
        rccSettigns: "RCC savienojums",
        rccUrl: "RCC-URL"
    },
    rccSpectroDialog: {
        100: "Izveidot Bluetooth savienojumu ar jÅ«su iekÄrtu. LÅ«dzam pÄrbaudÄ«t vai Bluetooth ir aktivÄts un jÅ«su instruments ir ieslÄgts ",
        101: "Instruments netika atpazÄ«ts. Vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        110: "PÄrliecinieties, ka Nano ir pieslÄgts un nospiediet  pogu, lai sÄktu inizializÄciju",
        111: "Nano netika atpazÄ«ts. Vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        112: "IzslÄgt Nano, 10 sekundes nogaidÄ«t, pieslÄgt par jaunu un turpinÄt",
        120: "Savienojas ar jÅ«su iekÄrtu, lÅ«dzam uzgaidÄ«t",
        121: "AparÄts netika atpazÄ«ts. Vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        200: "Nolieciet Spektrometru uz melnÄs kalibrÄÅ¡anas flÄ«zes un turpiniet, vai arÄ« nospiediet pogu uz spektrometra. ",
        201: "Nolieciet instrumentu uz melnÄs kalibrÄÅ¡anas flÄ«zes un turpiniet",
        202: "Nolieciet instrumentu uz melnÄs kalibrÄÅ¡anas flÄ«zes un nospiediet pogu uz instrumenta",
        205: "Nolieciet instrumentu uz baltÄs kalibrÄÅ¡anas flÄ«zes un turpiniet, vai arÄ« nospiediet pogu uz instrumenta. ",
        206: "Nolieciet instrumentu uz baltÄs kalibrÄÅ¡anas flÄ«zes un turpiniet",
        207: "Nolieciet instrumentu uz baltÄs kalibrÄÅ¡anas flÄ«zes un nospiediet pogu uz instrumenta. ",
        210: "Nolieciet instrumentu uz diagnostiskÄs flÄ«zes un turpiniet, vai arÄ« nospiediet pogu uz instrumenta. ",
        211: "Nolieciet instrumentu uz diagnostiskÄs flÄ«zes un turpiniet",
        212: "Nolieciet instrumentu uz diagnostiskÄs flÄ«zes un  nospiediet pogu uz instrumenta. ",
        215: "Aizveriet spektrometra pÄrsegu un turpiniet, vai arÄ« nospiediet pogu uz instrumenta",
        216: "Aizveriet instrumenta pÄrsegu un turpiniet",
        217: "Aizveriet spektrometra pÄrsegu un nospiediet pogu uz instrumenta",
        220: "Nolieciet instrumentu uz nulles kalibrÄÅ¡anas flÄ«zes un turpiniet, vai arÄ« nospiediet pogu uz instrumenta. ",
        221: "Nolieciet instrumentu uz nulles kalibrÄÅ¡anas flÄ«zes un turpiniet",
        222: "Nolieciet instrumentu uz nulles kalibrÄÅ¡anas flÄ«zes un nospiediet pogu uz instrumenta. ",
        224: "Place the instrument on calibration pad and continue or press instrument button",
        225: "Place the instrument on calibration pad and continue",
        226: "Place the instrument on calibration pad and press instrument button",
        227: "Place the instrument on calibration pad and press instrument button",
        295: "Pabeidziet kalibrÄÅ¡anu draivera logÄ",
        296: "Instrument is not connected, do you want to open connection to it?",
        297: "KalibrÄÅ¡ana tiek sagatavota, lÅ«dzam uzgaidÄ«t",
        298: "Notiek kalibrÄÅ¡ana, lÅ«dzam uzgaidÄ«t",
        299: "KalibrÄÅ¡ana tiek pabeigta, lÅ«dzam uzgaidÄ«t",
        300: "Nolieciet instrumentu uz parauga un turpiniet, vai arÄ« nospiediet pogu uz instrumenta. ",
        301: "Nolieciet instrumentu uz parauga un turpiniet",
        302: "Nolieciet instrumentu uz parauga un nospiediet pogu uz instrumenta. ",
        303: "Instrument is not calibrated, do you want to proceed with calibration?",
        304: "Instrument is not connected, do you want to open connection to it?",
        390: "Select measure mode",
        395: "Pabeidziet mÄrÄ«jumu draivera logÄ",
        397: "SagatavoÅ¡anÄs mÄrÄ«Å¡anai, lÅ«dzam uzgaidÄ«t",
        398: "MÄrÄ«Å¡ana, lÅ«dzam uzgaidÄ«t",
        399: "MÄrÄ«Å¡anas pabeigÅ¡ana, lÅ«dzam uzgaidÄ«t",
        498: "MÄrÄ«juma lejuplÄde, lÅ«dzam uzgaidÄ«t",
        499: "MÄrÄ«jumu lejuplÄde, lÅ«dzam uzgaidÄ«t",
        900: "IekÄrtas kÄ¼Å«da %{0}: %{1}. Vai vÄlaties mÄÄ£inÄt vÄlreiz?",
        901: "Radusies iekÅ¡Äja kÄ¼Å«da: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Datoram ir jÄbÅ«t Bluetooth savienojumam. Spektrometrs ir jÄsavieno pÄrÄ« ar datoru. NepiecieÅ¡ams Windows 10 ar 2018 automn atjauninÄjumu.",
        DatacolorSilent:
            "Izmantojot klusuma reÅ¾Ä«mu, Datacolor logi tiek parÄdÄ«ti tieÅ¡i %{name}. Å ajos logos spektrometra parametrus nevar mainÄ«t.",
        DatacolorUseDiagnosticTile: "Diagnostikas flÄ«zes lietoÅ¡ana uzlabo mÄrÄ«jumu kvalitÄti.",
        comPort: "Com pieslÄgums",
        diagnosticTile: "Izmantot Datacolor dialoga flÄ«zi ",
        measureModes: "Measure modes",
        measureModesOrder: "Measure modes order",
        model: "Modelis",
        noSpectroAvailable: "Spekrometrs nav pieejams",
        rccSpectroSettings: "Spektrometra iestatÄ«jumi",
        save: "SaglabÄt iestatÄ«jumus",
        silent: "Datacolor Silent",
        simulationPath: "SimulÄcijas marÅ¡ruts",
        spectroType: "Spektrometra tips",
        useProfiledValues: "Lietojiet profilÄtas vÄrtÄ«bas"
    },
    recirculateChannels: {
        recirculateAllChannels: "RecirkulÄt visÄs kolbÄs",
        recirculateChannels: "RecirkulÄt kolbÄ",
        recirculatingSpeed: "RecirkulÄcijas Ätrums",
        recirculatingTime: "RecirkulÄcijas laiks",
        startRecirculating: "SÄkt recirkulÄciju"
    },
    redlikeLight: {
        finishPreviousSteps: "LÅ«dzam pabeigt iepriekÅ¡Äjos soÄ¼us",
        searchBySpectro: "MeklÄt spektrometru",
        searchFormula: "MeklÄt receptÅ«ru",
        selectBase: "Select base",
        selectColor: "IzvÄlÄties toni",
        selectCustomer: "IzvÄlÄties klientu",
        selectFandeck: "IzvÄlÄties paleti",
        selectPackage: "IzvÄlÄties tilpumu",
        selectProduct: "IzvÄlÄties produktu",
        startSelectFandeck: "SÄkt ar paleti",
        startSelectProduct: "SÄkt ar produktu",
        stepByStepProgress: "Varat turpinÄt soli pa solim",
        typeHereToSearch: "MeklÄt",
        typeToFilter: "FiltrÄt"
    },
    restartModal: {
        computerNeedsRestart: "Datoram nepiecieÅ¡ama pÄrstartÄÅ¡ana",
        notCompletelyTranslated:
            "Lai nomainÄ«tu valodu nepiecieÅ¡ama programmatÅ«ras pÄrstartÄÅ¡ana. IespÄjams ka daÄ¼a no programmatÅ«ras vÄl nav pilnÄ«bÄ iztulkota",
        restartIsRequired: "Software restart is required after the changes have been made.",
        softwareNeedsRestart: "%{name} jÄpÄrstartÄ!"
    },
    searchPanel: {
        basePlaceholder: "or type a base name",
        baseStartPlaceholder: "Start by typing a base name",
        colorCodeNamePlaceholder: "or type a formula code/name",
        colorCodeNameStartPlaceholder: "Start by typing a formula code/name",
        colorCodePlaceholder: "IevadÄ«t vai izvÄlÄties krÄsas toni",
        colorCodeStartPlaceholder: "SÄkt, ierakstot receptÅ«ras kodu",
        colorNameCodePlaceholder: "or type a formula name/code",
        colorNameCodeStartPlaceholder: "Start by typing a formula name/code",
        colorNamePlaceholder: "IevadÄ«t vai izvÄlÄties krÄsas nosaukumu",
        colorNameStartPlaceholder: "SÄkt, ierakstot receptÅ«ras nosaukumu",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "IevadÄ«t vai izvÄlÄties krÄsu paleti",
        fandeckStartPlaceholder: "SÄkt, ierakstot paletes nosaukumu",
        formulaByColor: "MeklÄt pÄc toÅa nosaukuma",
        noResultsFound: "No results found",
        packagePlaceholder: "or type a package name",
        packageStartPlaceholder: "Start by typing a package name",
        productPlaceholder: "IzvÄlÄties vai ievadÄ«t krÄsas nosaukumu",
        productStartPlaceholder: "SÄkt, ierakstot produkta nosaukumu",
        standard: "Standarts",
        typeFandeckToFilter: "Lai filtrÄtu, ievadÄ«t krÄsu paletes nosaukumu",
        typeProductToFilter: "Lai filtrÄtu, ievadÄ«t produkta nosaukumu"
    },
    sendOrderModal: {
        customNote: "IndividuÄlÄs piezÄ«mes",
        noCompatibleServers: "JÅ«su tÄ«klÄ nav savietojamu serveru",
        orderOverview: "PasÅ«tÄ«jumu pÄrskats",
        selectTargetMachine: "IzvÄlÄties gala iekÄrtu",
        sendOrder: "NosÅ«tÄ«t pasÅ«tÄ«jumu",
        sendOrderTo: "JÅ«su pasÅ«tÄ«jums tiek nosÅ«tÄ«ts uz %{serverName}",
        targetMachine: "Gala iekÄrta"
    },
    server: {
        computerId: "Datora ID",
        ip: "IP",
        selectServer: "LÅ«dzam izvÄlÄties vienu no pieejamajiem serveriem",
        server: "Serveris"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "AktÄ«vie servera spraudÅi",
        currentlyActive: "Patreiz aktÄ«vie spraudÅi",
        plugin: "Spraudnis",
        pluginName: "SpraudÅa nosaukums",
        statusActive: "AktÄ«vs",
        statusInactive: "NeaktÄ«vs"
    },
    serviceActionsSettings: {
        canisterLevel: "LÄ«menis kolbÄs",
        capClose: "AizvÄrt",
        capMiddle: "Vidus",
        capOpen: "AtvÄrt  ",
        cleanAllChannels: "TÄ«rÄ«t visas sprauslas",
        cleanChannels: "TÄ«rÄ«t sprauslas",
        computer: "Dators",
        computerReboot: "Datora pÄrstartÄÅ¡ana",
        computerShutdown: "Datora izslÄgÅ¡ana",
        connectMachine: "Pievienot maÅ¡Ä«nu",
        general: "VispÄrÄ«gi",
        initialize: "InicializÄt",
        noMachineIsConnected: "MaÅ¡Ä«na nav pievienota",
        plug: "Iespraust",
        plugger: "Spraudnis",
        punch: "Å tancÄÅ¡ana",
        puncher: "Å tance",
        purgeChannels: "Skalot sprauslas",
        recirculate: "RecirkulÄt",
        recirculateAllChannels: "CirkulÄcija visÄs kolbÄs",
        recirculateChannels: "CirkulÄcija kolbÄs",
        serviceActions: "Servisa darbÄ«bas",
        setCanisterLevel: "LÄ«menis kolbÄs",
        shelfDown: "Plaukts uz leju",
        shelfUp: "Plaukts uz augÅ¡u",
        showServiceWindow: "ParÄdÄ«t servisa logu",
        smartPurgeAllChannels: "Smart purge all channels",
        smartPurgeChannels: "Smart purge channels",
        startErrorReset: "StartÄjiet kÄ¼Å«du atcelÅ¡anu",
        startHardReset: "Piespiedu pÄrstartÄÅ¡ana",
        startReset: "SÄkt pÄrstartÄÅ¡anu",
        stirAllCanisters: "MaisÄ«t visas kolbas",
        stirCanisters: "MaisÄ«t kolbas",
        stirCanistersMore: "MaisÄ«t kolbas"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matte",
        pearl: "Pearl",
        satin: "Satin",
        selectGlossLevel: "Compare the color sample to the gloss scale and select gloss level",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "KalibrÄt",
        calibrateInstrument: "Calibrate instrument",
        connectDevice: "Savienot ar ierÄ«ci",
        connectedTo: "Savienot ar",
        connectingDevice: "IerÄ«ce tiek savienota ar",
        deselectAll: "Atcelt visus",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "IekÄrta nav kalibrÄta",
        eraseResult: "Erase result",
        filter: "Filtrs",
        foundInFormulas: "Atrasts starp toÅiem",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Your instrument needs to be calibrated.",
        manualInput: "Manual input",
        measure: "Measure",
        measurementResult: "MÄrÄ«jumu rezultÄts",
        noFilters: "Filtri nav pieejami",
        noFormulas: "KrÄsu toÅi nav atrasti",
        noSelectedSpectro: "Nav izvÄlÄts spektrometrs",
        notSelected: "Nav izvÄlÄts",
        pressConnectButton: "Parliecinieties, ka iekÄrta ir pieslÄgta un nospiediet savienoÅ¡anas pogu",
        searchFormulas: "MeklÄt receptÅ«ru",
        selectSpectro: "IzvÄlÄties spektrometru",
        showDetails: "ParÄdÄ«t detaÄ¼as",
        skipCalibration: "Skip calibration",
        spectroIsConnected: "Spektrometrs ir pievienots",
        spectroIsReady: "Spektrometrs ir gatavs",
        spectroReady: "Spektrometrs ir gatavs tÄlÄkÄm darbÄ«bÄm",
        startCalibrateNow: "Start calibrate now",
        startMeasureText: "JÅ«su ierÄ«ce ir kalibrÄta, varat sÄkt mÄrÄ«jumus",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Delta E (CIE 2000) tolerance"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "IndividuÄli %{1} %{2}",
        deleteSelectedRecords: "DzÄst izvÄlÄtos ierakstus",
        exportHistory: "EksportÄt vÄsturi",
        finishFormula: "Pabeigt receptÅ«ru",
        foundInFormulas: "TonÄÅ¡anas receptÅ«ras",
        hideHiddenRecords: "NerÄdÄ«t slÄptos ierakstus",
        hideSelectedRecord: "SlÄpt izvÄlÄtos ierakstus",
        historicalFormula: "Historical formula",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Atjaunot izvÄlÄtos ierakstus",
        showAllRecords: "ParÄdÄ«t visus ierakstus",
        standardFormula: "Standard formula",
        unknownFormula: "Unknown formula"
    },
    stirCanisters: {
        selectCanisters: "IzvÄlÄties kolbas",
        startStirring: "SÄkt maisÄ«Å¡anu",
        stirAllCanisters: "MaisÄ«t visas kolbas",
        stirCanisters: "MaisÄ«t  kolbas",
        stirringSpeed: "MaisÄ«Å¡anas Ätrums",
        stirringTime: "MaisÄ«Å¡anas laiks"
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Kods %{code} nav atrodams",
        pleaseScanBarcode: "LÅ«dzam skanÄt bÄzes produkta svÄ«trukodu",
        testBarcodes: "SvÄ«trukodu tests"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "PÄdÄjais",
        next: "NÄkoÅ¡ais  "
    },
    ufiCodeModal: {
        currentStatus: "Current Status",
        detailedInfoForColorant: "Detailed info for colorant %{colorantName}",
        userSetUfiCode: "User set UFI code, current value"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Base UFI code validation",
        confirmColorantRefilling: "Confirm colorant refilling",
        enableUfiCodes: "Enable UFI codes",
        printUfiCode: "Print if amount of colorant is over",
        printUfiCodePercentage: "Print percentage if amount of colorant is over",
        scanOrTypeUfiCode: "Scan or type UFI code",
        scanOrTypeUfiCodeOfBase: "Scan or type UFI code of base can",
        ufiCodesByPercentage: "Use UFI codes by percentage",
        ufiCodesFromDatabase: "Use UFI codes from the database",
        ufiCodesFromLastFilling: "Use UFI codes from the last filling"
    },
    userSettings: {
        addUser: "Pievienot lietotÄju",
        assignedUserGroups: "LietotÄju grupas",
        availableUserGroups: "PieejamÄs lietotÄju grupas",
        barcode: "SvÄ«trukods",
        confirmNewPassword: "Apstipriniet paroli",
        editPassword: "MainÄ«t paroli",
        editUser: "MainÄ«t lietotÄju",
        enableAutoLogin: "AtÄ¼aut automÄtisku pierakstÄ«Å¡anos",
        newPassword: "Jauna parole",
        noChange: "Nav saglabÄta neviena izmaiÅa",
        oldPassword: "VecÄ parole  ",
        password: "Parole",
        passwordsDoNotMatch: "Paroles nesakrÄ«t",
        restoreUser: "Å is lietotÄjs ir dzÄsts. Vai vÄlaties viÅu atjaunot?",
        userGroup: "User Group",
        userGroups: "LietotÄju grupas",
        userManagement: "LietotÄju pÄrvaldÄ«Å¡ana",
        userSettings: "LietotÄju iestatÄ«jumi",
        username: "LietotÄja nosaukums",
        usernameIsMissing: "Nav lietotÄja vÄrda"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Piektdiena",
        monday: "Pirmdiena",
        saturday: "Sestdiena",
        sunday: "SvÄtdiena",
        thursday: "Ceturtdiena",
        tuesday: "Otrdiena",
        wednesday: "TreÅ¡diena"
    },
    welcome: {
        availableDatabase: "Serveris nesavienojas ar datu bÄzi. LÅ«dzam pÄrbaudÄ«t datu bÄzes konfigurÄciju",
        availableDatabaseLocalError: "KÄ¼Å«da savienojoties ar lokÄlo datu bÄzi (nepareizi dati, nepareiza parole)",
        availableDatabaseLocalMissing: "Nav lokÄlÄs datu bÄzes",
        availableDatabaseLocalUpdate: "NepiecieÅ¡ams lokÄlo datu bÄzi aktualizÄt uz jaunÄku versiju",
        availableDatabaseMainAndLocalError:
            "KÄ¼Å«da savienojoties ar centrÄlo un lokÄlo datu bÄzi (nepareizi dati, nepareiza parole)",
        availableDatabaseMainAndLocalMissing: "TrÅ«kst centrÄlÄs un lokÄlÄs datu bÄzes",
        availableDatabaseMainAndLocalUpdate:
            "NepiecieÅ¡ams gan centrÄlo, gan lokÄlo datu bÄzi aktualizÄt uz jaunÄku versiju",
        availableDatabaseMainError: "KÄ¼Å«da savienojoties ar centrÄlo datu bÄzi (nepareizi dati, nepareiza parole)",
        availableDatabaseMainMissing: "TrÅ«kst centrÄlÄs datu bÄzes",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "NepiecieÅ¡ams centrÄlo datu bÄzi aktualizÄt uz jaunÄku versiju",
        closing: "Programma tiek aizvÄrta",
        compatibility:
            "LÅ«dzam pÄrbaudÄ«t jÅ«su servera versiju. JÅ«su programmatÅ«ra ir savietojama tikai ar severa versiju %{0} vai augstÄku ",
        compatibilityCheck: "Tiek veikta savietojamÄ«bas pÄrbaude",
        compatibilityDatabase: "JÅ«su datu bÄze nav savietojama ar serveri. LÅ«dzam pÄrbaudÄ«t datu bÄzes konfigurÄciju",
        connectingServer: "Savienojums ar serveri %{ip}",
        databaseCompatibility: "JÅ«su datu bÄze nav savietojama ar aktuÄlo programmatÅ«ru. ",
        databasesCompatibility: "JÅ«su datu bÄzes nav savietojamas ar aktuÄlo programmatÅ«ru. ",
        licenseVerification: "Tiek pÄrbaudÄ«ta licence",
        loading: "LÄdÄjas",
        lostConnection: "Savienojums ar serveri tika pÄrtraukts",
        moduleMessage:
            "UzmanÄ«gi ar moduÄ¼a izvÄli, jo turpmÄkÄs moduÄ¼a izmaiÅas pieejamas tikai priviliÄ£Ätiem lietotÄjiem ",
        refresh: "AktualizÄcija",
        restoring: "Atjauno savienojumu",
        selectModule: "LÅ«dzam izvÄlÄties vienu no pieejamajiem moduÄ¼iem",
        stopUpdate: "Izbeigt aktualizÄciju",
        updateDatabase: "Datu bÄze aktualizÄta",
        updatingDatabase: "Datu bÄze tiek aktualizÄta",
        updatingDatabases: "Datu bÄzes tiek aktualizÄtas",
        updatingWarning:
            "LÅªDZAM NEAIZVÄRT Å O LOGU! Notiek neatgriezenisks process. AizvÄrÅ¡ana var radÄ«t neatgriezeniskus programmatÅ«ras bojÄjumus.",
        updatingWarningInfo:
            "Do not close this window as it would result in the necessity to do the update from scratch."
    }
};
